import React from 'react';
// hover color for tag is #000

export function MapLine({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 483 3'
      {...props}
    >
      <g fill='none' fillRule='evenodd' strokeDasharray='4 6'>
        <g stroke='#FFF' strokeWidth='1'>
          <path
            d='M109.5 98.5L592.5 98.5'
            transform='translate(-161 -2243) translate(40 1990) translate(12 156)'
          />
        </g>
      </g>
    </svg>
  );
}

export function CheckCircle({ color = '#55dcac', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill={color} viewBox='0 0 16 16'>
      <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
    </svg>
  );
}

export function AndCounting({ stroke = 'currentColor', ...props }) {
  return (
    <svg height='438' viewBox='0 0 576 438' width='576' xmlns='https://www.w3.org/2000/svg'>
      <linearGradient id='a'>
        <stop offset='0' stopColor='#fff' />
        <stop offset='1' stopColor='#dde5fc' />
      </linearGradient>
      <linearGradient id='b' x1='0%' y1='50%' y2='50%' />
      <linearGradient id='c' x1='0%' y1='49.994%' y2='49.994%' />
      <linearGradient id='d' x1='0%' y1='50.022%' y2='50.022%' />
      <linearGradient id='e' x1='-.158%' x2='100.158%' y1='50%' y2='50%'>
        <stop offset='0' stopColor='#ed5f40' />
        <stop offset='1' stopColor='#7685f5' />
      </linearGradient>
      <linearGradient id='f' x1='-.202%' x2='100.202%' y1='49.993%' y2='49.993%'>
        <stop offset='0' stopColor='#7685f5' />
        <stop offset='1' stopColor='#6bd0b1' />
      </linearGradient>
      <g fill='none' fillRule='evenodd'>
        <path
          d='m23.102 303.17 208.843 133.086 23.255 1.651 320.564-184.233-238.194-131.216z'
          fill='#bfc9dd'
          fillRule='nonzero'
          opacity='.3'
        />
        <g fillRule='nonzero'>
          <path d='m.444 292.699.028 8.999 231.9 134.945-.029-8.999z' fill='#efeff0' />
          <path d='m232.343 427.644.028 9 320.296-184.519-.023-8.999z' fill='#bfc9dd' />
          <path
            d='m.444 184.699 231.9 134.945 320.3-184.518-231.9-134.945z'
            fill='url(#b)'
            transform='translate(0 108)'
          />
        </g>
        <path
          d='m320.609 108-319.609 184.09 36.391 20.91 319.609-184.09z'
          fill='#f64621'
          fillRule='nonzero'
        />
        <path
          d='m37 313.815v9.185l-36.972-21.063-.028-8.937z'
          fill='#f64621'
          fillRule='nonzero'
          opacity='.7'
        />
        <path
          d='m81 339 320-185m-270 216 320-186m-272 212 320-185m-416 76 195 114m-147-140 195 114m-143-147 195 114m-150-138 195 114m-152-140 195 114m-154-138 195 114'
          stroke='#bfc9dd'
        />
        <path d='m36 292 48-27' stroke='#fff' strokeLinecap='round' strokeWidth='9' />
        <g fillRule='nonzero'>
          <path
            d='m399.85 16-45.85 26.268 51.888 29.732 46.112-26.422zm-45.85 27v138.281l51 29.719v-138.281z'
            fill='#86dab1'
          />
          <path d='m451 46v137.701l-45 26.299v-137.701z' fill='#48cba3' />
          <path d='m271.852 169-45.852 26.268 51.89 29.732 46.11-26.422z' fill='#3e6bf9' />
          <path d='m227 195v59.401l51 29.599v-59.401z' fill='#3e6bf9' />
          <path d='m324 199v58.913l-45 26.087v-58.913z' fill='#2021c5' />
          <g>
            <path
              d='m19.689 38.797-6.447-3.734 20.06-34.948 6.446 3.734z'
              fill='url(#c)'
              transform='translate(388)'
            />
            <path
              d='m6.632 40.32-6.447-3.734 3.895-6.73 6.448 3.74z'
              fill='url(#d)'
              transform='translate(388)'
            />
            <path
              d='m427.748 3.85 3.95 2.182-23.958 41.738-13.108-7.449 3.896-6.725 9.16 5.202z'
              fill='#a3b0c6'
            />
          </g>
          <path
            d='m429.922 124v1.962c.4-.172.833-.262 1.27-.264.35.003.69.119.967.328.289.241.5.558.61.913.161.49.236 1.002.22 1.515l-2.345 1.31c0-.72-.14-1.191-.413-1.4-.272-.21-.623-.188-1.069.063-.23.123-.442.276-.628.456-.173.17-.318.364-.432.575a2.478 2.478 0 0 0 -.248.648 2.49 2.49 0 0 0 -.08.667c-.007.19.021.38.085.561a.628.628 0 0 0 .276.347c.163.088.344.136.53.142.271.01.543-.003.811-.042.477-.055.956-.08 1.435-.077a2.61 2.61 0 0 1 1.107.233c.314.16.567.414.722.725.187.433.275.9.258 1.37 0 .527-.076 1.053-.225 1.56-.157.51-.375 1.001-.652 1.46a7.29 7.29 0 0 1 -1.013 1.315c-.4.415-.845.787-1.327 1.11v1.802l-1.285.721v-1.798c-.411.188-.849.317-1.299.383-.381.055-.77 0-1.12-.16a1.746 1.746 0 0 1 -.774-.853 4.099 4.099 0 0 1 -.3-1.702l2.345-1.315c-.015.335.036.67.15.986.074.195.22.358.408.456a.86.86 0 0 0 .572.042c.229-.058.448-.147.651-.265.243-.134.467-.298.666-.489.18-.18.338-.38.47-.597.122-.21.22-.431.29-.662.061-.22.093-.447.094-.676a1.647 1.647 0 0 0 -.094-.616.71.71 0 0 0 -.29-.36c-.16-.09-.341-.14-.526-.142-.26-.01-.521.006-.778.046-.479.069-.961.105-1.445.11a2.592 2.592 0 0 1 -1.116-.224 1.586 1.586 0 0 1 -.717-.717 3.12 3.12 0 0 1 -.263-1.369c0-.519.077-1.035.225-1.533a6.38 6.38 0 0 1 .643-1.47 8.094 8.094 0 0 1 1.008-1.333c.392-.42.832-.793 1.313-1.113v-1.935zm-128.012 108v2.06c.4-.18.83-.275 1.267-.28.351.005.69.129.966.351.292.252.506.586.615.96.16.514.234 1.05.22 1.59l-2.345 1.382c0-.763-.14-1.253-.408-1.474-.268-.22-.624-.197-1.074.067a2.741 2.741 0 0 0 -1.304 1.786 2.753 2.753 0 0 0 -.085.701 1.83 1.83 0 0 0 .085.595c.05.15.149.278.281.36.16.095.34.146.525.15.273.01.546-.002.817-.04.476-.061.955-.09 1.435-.086.382-.001.76.084 1.107.25.317.16.572.424.727.749.19.454.279.946.258 1.44a5.886 5.886 0 0 1 -.225 1.642 6.964 6.964 0 0 1 -.647 1.536 7.668 7.668 0 0 1 -1.018 1.382c-.397.448-.84.85-1.323 1.2v1.92l-1.285.759v-1.887c-.414.197-.853.331-1.304.399-.38.06-.768.002-1.117-.163a1.826 1.826 0 0 1 -.778-.903 4.411 4.411 0 0 1 -.296-1.79l2.345-1.383c-.013.354.04.708.155 1.042a.882.882 0 0 0 .408.48c.179.083.38.098.568.043a2.38 2.38 0 0 0 .657-.278c.242-.142.466-.315.666-.514.179-.191.336-.402.469-.629.125-.216.223-.449.29-.691.071-.235.11-.48.113-.725a1.962 1.962 0 0 0 -.094-.653.785.785 0 0 0 -.29-.38 1.12 1.12 0 0 0 -.526-.148 3.943 3.943 0 0 0 -.783.048c-.478.078-.961.116-1.445.115a2.479 2.479 0 0 1 -1.112-.23 1.64 1.64 0 0 1 -.717-.759 3.341 3.341 0 0 1 -.263-1.44 5.754 5.754 0 0 1 .225-1.617 6.951 6.951 0 0 1 .643-1.541 8.26 8.26 0 0 1 1.008-1.407c.393-.44.834-.833 1.314-1.171v-2.036l1.276-.782z'
            fill='#fff'
          />
          <path d='m125.85 282-45.85 26.273 51.888 29.727 46.112-26.417z' fill='#f64621' />
          <path d='m81 308v31.977l51 30.023v-31.981z' fill='#f64621' />
          <path d='m176 311v31.623l-45 26.377v-31.623z' fill='#f64621' />
          <path
            d='m154.917 329v2.067c.4-.185.835-.28 1.275-.279.351.001.692.123.968.346.29.254.502.588.611.961.162.514.237 1.052.221 1.591l-2.35 1.385c0-.765-.142-1.255-.414-1.476-.273-.221-.626-.197-1.073.067-.232.128-.444.29-.63.48a2.66 2.66 0 0 0 -.437.607 2.925 2.925 0 0 0 -.244.677c-.06.23-.086.469-.08.707-.008.2.021.4.084.591.048.151.146.28.278.365.162.093.345.143.531.144.272.014.544.002.814-.038.477-.058.958-.085 1.438-.082a2.53 2.53 0 0 1 1.11.245c.315.17.569.437.724.765.187.455.274.948.254 1.442a6.098 6.098 0 0 1 -.22 1.643 7.085 7.085 0 0 1 -.654 1.539c-.287.497-.628.96-1.016 1.379-.4.438-.847.83-1.33 1.168v1.899l-1.27.807v-1.894a4.808 4.808 0 0 1 -1.303.404c-.383.058-.774 0-1.124-.168a1.862 1.862 0 0 1 -.78-.899 4.53 4.53 0 0 1 -.297-1.798l2.352-1.384c-.012.355.04.708.155 1.043a.79.79 0 0 0 .382.476.76.76 0 0 0 .6.053c.23-.06.45-.153.654-.274a3.055 3.055 0 0 0 1.138-1.144c.123-.22.221-.454.292-.697a2.87 2.87 0 0 0 .094-.711c.008-.22-.024-.44-.094-.65a.777.777 0 0 0 -.292-.384 1.105 1.105 0 0 0 -.527-.144 3.622 3.622 0 0 0 -.785.048 9.48 9.48 0 0 1 -1.443.11 2.432 2.432 0 0 1 -1.12-.23 1.666 1.666 0 0 1 -.719-.76 3.327 3.327 0 0 1 -.263-1.441c0-.547.076-1.09.225-1.615a6.897 6.897 0 0 1 .645-1.548 8.462 8.462 0 0 1 1.01-1.408c.396-.44.837-.833 1.317-1.173v-2.033z'
            fill='#fff'
          />
        </g>
        <path d='m279 284v-58.913l45-26.087m-148 112-45 26.377v31.623' stroke='#fff' />
        <path d='m249 268-73 42' stroke='url(#e)' />
        <path d='m381 194-57 33' stroke='url(#f)' />
        <path
          d='m268 320.456c-9.155.297-18.766-5.717-30.223-16.619-20.342-19.385-38.047 13.31-48.979 42.478a234.505 234.505 0 0 0 -7.355 23.595c-1.725 6.664-5.329 17.17-11.443 20.09'
          stroke='#f64621'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m403 222.17c-9.63 5.037-21.767-3.768-42.126-23.722-21.165-20.754-40.95 57.476-61.943 93.58-11.466 19.715-21.395 28.622-31.931 28.972'
          stroke='#3e6bf9'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m481 94s-29.703 13.759-57.923 95.13c-6.467 18.659-12.127 29.292-19.077 32.87'
          stroke='#86dab1'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m278 224-51-29m179 15v-137.701l45-26.299m-97-3 51 29m-324 236 51 29'
          stroke='#fff'
        />
      </g>
    </svg>
  );
}
export function CircleGraphicIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg height='434' viewBox='0 0 1351 434' width='1351' xmlns='https://www.w3.org/2000/svg'>
      <defs>
        <path id='a' d='m0 0h1351v434h-1351z' />
        <linearGradient id='b' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0' stopColor='#fff' />
          <stop offset='1' stopColor='#fff' stop-opacity='0' />
        </linearGradient>
        <mask id='c' fill='#fff'>
          <use fill='#fff' fillRule='evenodd' />
        </mask>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <use fill='#fff' />
        <g stroke='#dedede'>
          <circle cx='707' cy='207' mask='url(#c)' r='71.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='355.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='537.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='199.5' />
        </g>
        <path d='m100 0h367v90h-367zm832 0h367v90h-367z' fill='url(#b)' mask='url(#c)' />
        <path
          d='m932 352h367v90h-367z'
          fill='url(#b)'
          mask='url(#c)'
          transform='matrix(-1 0 0 -1 2231 794)'
        />
        <path
          d='m100 352h367v90h-367z'
          fill='url(#b)'
          mask='url(#c)'
          transform='matrix(-1 0 0 -1 567 794)'
        />
      </g>
    </svg>
  );
}
export function MenuIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#000'
          d='M15 13c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1zm0-6c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1zm0-6c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1z'
        />
      </g>
    </svg>
  );
}
export function Motif({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='https://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 167 139'
      {...props}
    >
      <path
        fill='#FFF'
        fillOpacity='.4'
        fillRule='evenodd'
        d='M166.966-119.577H9.499l14.215-17.863.08-.103v-30.93h119.378v30.815h15.426v-46.33L8.368-184v79.95h149.11l-14.226 18.093-.08.104-8.368 30.641-85.645-4.832-25.365-26.603H8.367v46.963H0V52.719l134.85 68.982V139H167l-.034-258.577zM77.99-24.042l-8.42.103V47L35 30.01V-42h57L77.991-24.042zm56.627 1.168l-.079.103V78.142L134.55 81 100 63.117V-38.94L157-41l-22.382 18.126z'
      />
    </svg>
  );
}
export function SmallMotif({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='147'
      height='112'
      viewBox='0 0 147 112'
      {...props}
    >
      <path
        fill='#FFF'
        fillOpacity='.4'
        fillRule='evenodd'
        d='M267.064-240.47H15.194L37.93-269.12l.128-.166v-49.61h190.947v49.425h24.675v-74.312l-240.297-.019v128.24h238.505l-22.755 29.02-.128.166-13.384 49.148-136.992-7.75L38.06-187.65H13.384v75.327H0V35.891l215.695 110.646v27.747h51.424l-.055-414.754zM123.878-86.256l-13.483.165V27.605L55.035.374v-115.411h91.277l-22.434 28.781zm90.621.881l-.126.166V76.19l.018 4.57-55.328-28.6v-163.23l91.277-3.293-35.84 28.99z'
      />
    </svg>
  );
}
export function Motif2({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='https://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 600 164'
      {...props}
    >
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M0 967.552h679.076l-62.371 78.592-.351.456v136.081H92.569v-135.575H24.884v203.843l659.155.051V899.233H29.797l62.421-79.604.351-.456V684.357h523.785v138.308h67.685V616.038h-62.772L708 535.978V216.221L117.102-76.116V-155H0V967.552zm412.986-425.355V213L584 298.094V623H324l88.986-80.803zm-315.634-.572l30.987-.454-4.405-457.657-.05-12.514L294 155.793V621H36l61.352-79.375z'
        opacity='.475'
      />
    </svg>
  );
}

export function MotifThree({ stroke = 'currentColor', ...props }) {
  return (
    <svg
      height='682'
      viewBox='0 0 708 682'
      width='708'
      xmlns='https://www.w3.org/2000/svg'
      {...props}
    >
      <linearGradient id='a' x1='50%' x2='50%' y1='35.605%' y2='48.097%'>
        <stop offset='0' stopColor='#f9f9f9' />
        <stop offset='1' stopColor='#fff' />
      </linearGradient>
      <path
        d='m0 1122.552h679.076l-62.371 78.592-.351.456v136.081h-523.785v-135.575h-67.685v203.843l659.155.051v-351.767h-654.242l62.421-79.604.351-.456v-134.816h523.785v138.308h67.685v-206.627h-62.772l86.733-80.06v-319.757l-590.898-292.337v-78.884h-117.102zm412.986-425.355v-329.197l171.014 85.094v324.906h-260zm-315.634-.572 30.987-.454-4.405-457.657-.05-12.514 170.116 84.793v465.207h-258z'
        fill='url(#a)'
        fillRule='evenodd'
        opacity='.9'
      />
    </svg>
  );
}
export function MotifMap({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='167'
      height='323'
      viewBox='0 0 167 323'
      {...props}
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#F6F6F6'>
          <g>
            <g>
              <path
                d='M-2.966 74.577h157.467L140.286 92.44l-.08.103v30.93H20.828V92.657H5.402v46.33l150.23.012V59.05H6.523l14.226-18.093.08-.104 8.368-30.641 85.645 4.832 25.365 26.603h15.427V-5.316H164V-97.719L29.15-166.701V-184H-3l.034 258.577zM86.01-20.958l8.42-.103V-92L129-75.01V-3H72l14.009-17.958zm-56.627-1.168l.079-.103v-100.913L29.45-126 64-108.117V-6.06L7-4l22.382-18.126z'
                transform='translate(-184 120) translate(0 64) translate(187) rotate(-180 80.5 -22.5)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function RightArrow({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#FFF'
          d='M10.784 3.089l.07.057 5 5 .011.013a.503.503 0 0 1 .033.039l-.044-.052A.502.502 0 0 1 16 8.5v.02a.503.503 0 0 1-.005.052L16 8.5a.502.502 0 0 1-.089.284l-.013.018a.503.503 0 0 1-.033.04l-.011.012-5 5a.5.5 0 0 1-.765-.638l.057-.07L14.293 9H.5a.5.5 0 0 1-.09-.992L.5 8h13.793l-4.147-4.146a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057z'
        />
      </g>
    </svg>
  );
}

export function SpecsLogo() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='143' height='33' viewBox='0 0 143 33'>
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF'>
          <path d='M35.16 31.51c.92.322 2.096.486 3.497.486 1.926 0 3.428-.336 4.462-.995 1.025-.655 1.544-1.586 1.544-2.768 0-1.046-.357-1.878-1.062-2.475-.712-.602-1.85-1.03-3.386-1.271l-2.623-.403c-.873-.13-1.486-.303-1.822-.52-.35-.223-.525-.575-.525-1.044 0-.496.284-.88.847-1.136.542-.25 1.334-.376 2.35-.376.9 0 1.615.136 2.123.403.499.263.881.691 1.137 1.274l2.621-.3c-.298-1.147-.91-2.002-1.818-2.543-.935-.557-2.278-.839-3.99-.839-1.248 0-2.335.149-3.231.443-.894.292-1.581.712-2.045 1.248a2.813 2.813 0 0 0-.696 1.896c0 1.081.395 1.93 1.175 2.526.788.602 2.057 1.024 3.771 1.256l2.142.297c.77.107 1.343.289 1.7.54.371.258.56.62.56 1.076 0 .566-.282.998-.835 1.285-.538.278-1.344.42-2.399.42-1.176 0-2.072-.196-2.665-.581-.584-.38-.945-.98-1.076-1.784h-2.722c.102.974.392 1.788.861 2.422.483.65 1.19 1.142 2.104 1.462M132.437 31.51c.92.322 2.097.486 3.497.486 1.926 0 3.427-.336 4.462-.995 1.026-.655 1.544-1.586 1.544-2.768 0-1.046-.357-1.878-1.06-2.475-.713-.602-1.853-1.03-3.388-1.271l-2.622-.403c-.874-.13-1.487-.303-1.822-.52-.35-.223-.526-.575-.526-1.044 0-.496.285-.88.847-1.136.543-.25 1.334-.376 2.35-.376.902 0 1.615.136 2.124.403.499.263.88.691 1.136 1.274l2.621-.3c-.298-1.147-.91-2.002-1.817-2.543-.935-.557-2.278-.839-3.991-.839-1.247 0-2.335.149-3.232.443-.892.292-1.58.712-2.043 1.248a2.809 2.809 0 0 0-.696 1.896c0 1.081.395 1.93 1.175 2.526.787.602 2.057 1.024 3.771 1.256l2.14.297c.772.107 1.344.289 1.703.54.37.258.558.62.558 1.076 0 .566-.281.998-.835 1.285-.537.278-1.344.42-2.399.42-1.175 0-2.073-.196-2.665-.581-.583-.38-.944-.98-1.075-1.784h-2.723c.102.974.392 1.788.861 2.422.483.65 1.19 1.142 2.105 1.462M65.588 24.98c.417-.37.626-.881.626-1.531 0-.676-.206-1.192-.616-1.55-.41-.357-.967-.537-1.667-.537h-5.558v4.173h5.558c.688 0 1.24-.185 1.657-.555m1.836-4.797c.952.722 1.429 1.81 1.429 3.266 0 1.43-.473 2.483-1.42 3.159-.945.676-2.193 1.015-3.74 1.015h-5.32v4.095h-2.64V19.1h7.96c1.534 0 2.779.36 3.73 1.082' />
        </g>
        <path
          fill='#FFF'
          d='M92 29.77V32H79V19h12.98v2.23H81.735v3.456h8.392l-1.267 1.668h-7.125v3.416z'
        />
        <g fill='#FFF'>
          <path d='M116.031 30.97c-1.254.841-2.951 1.261-5.092 1.261-1.615 0-3.03-.25-4.244-.748-1.216-.5-2.161-1.24-2.837-2.225-.676-.985-1.014-2.192-1.014-3.624 0-1.43.338-2.644 1.014-3.643.676-.997 1.621-1.75 2.837-2.254 1.214-.504 2.629-.759 4.244-.759 2.14 0 3.841.434 5.102 1.3 1.26.866 1.976 2.075 2.146 3.624h-2.6c-.275-.84-.8-1.49-1.575-1.95-.776-.46-1.8-.689-3.073-.689-1.655 0-2.968.378-3.94 1.133-.971.754-1.457 1.834-1.457 3.238 0 1.406.486 2.488 1.457 3.25.972.76 2.285 1.142 3.94 1.142 1.26 0 2.278-.23 3.053-.69a3.536 3.536 0 0 0 1.595-1.95h2.6c-.183 1.55-.902 2.745-2.156 3.585M32.122 12.846c1.86.033 2.12-.182 2.185-1.809V2.87h-2.053v-.548l4.302-.018 4.564 8.6 4.366-8.6h4.173v.532h-2.053v10.01h2.037v.531h-6.291v-.53h2.07v-9.23l-4.986 9.976h-.328L34.876 3.8v7.237c0 .597.1 1.145.261 1.361.213.3.717.465 1.468.465.114 0 .243 0 .457-.017v.531h-4.94v-.53zM51.962 12.88c1.24-.018 1.517-.2 2.25-1.479l5.28-9.594L65.18 12.88h1.516v.498h-5.752v-.498h1.841l-1.663-3.402h-5.28l-1.123 2.057-.017.067c-.18.415-.18.415-.18.547 0 .267.163.516.44.65.164.064.26.081.718.081h.913v.498h-4.63v-.498zm8.883-3.934L58.58 4.43l-2.43 4.516h4.695zM68.985 12.846h2.134V2.836h-2.134v-.532h7.563c1.401 0 2.378.217 3.325.731 1.499.814 2.492 2.69 2.492 4.715 0 2.307-1.239 4.316-3.128 5.08-.978.38-1.988.547-3.374.547h-6.878v-.53zm6.52 0c.293 0 1.043-.1 1.563-.2 1.094-.215 1.745-.613 2.3-1.443.521-.78.829-1.992.829-3.254 0-1.925-.634-3.586-1.694-4.416-.619-.463-1.564-.697-2.916-.697h-2.283v10.01h2.2z' />
        </g>
        <path fill='#FFF' d='M85 12.473h2.31V2.528H85V2h7v.528h-2.31v9.945H92V13h-7z' />
        <g fill='#FFF'>
          <path d='M96.418 9.098h.443c.115.7.262 1.185.508 1.635.821 1.485 2.775 2.453 4.974 2.453 2.15 0 3.579-.918 3.579-2.27 0-.55-.247-1.1-.673-1.434a1.94 1.94 0 0 0-.527-.318c-.77-.233-1.92-.4-3.364-.45-1.854-.083-3.3-.518-4.119-1.269-.657-.6-.986-1.302-.986-2.103 0-.985.526-1.97 1.413-2.637.74-.568 1.97-.885 3.398-.885 1.526 0 2.659.3 4.217 1.135l.984-.818h.395v4.174h-.427c-.41-2.588-2.249-3.974-5.22-3.974-2.084 0-3.413.769-3.413 1.987 0 .367.147.734.378 1.002.722.8 1.624 1.084 3.905 1.184 2.035.1 3.48.534 4.284 1.286.691.667 1.05 1.467 1.05 2.336 0 1.002-.491 1.936-1.362 2.587-.787.584-2.15.918-3.692.918-1.576 0-2.43-.217-4.302-1.084l-1 .767-.443-.05V9.098zM121.72 3.256c1.313 1.135 2.069 2.771 2.069 4.456 0 3.389-2.807 5.959-6.5 5.959-3.662 0-6.335-2.52-6.335-5.976 0-3.321 2.888-5.958 6.515-5.958 1.674 0 3.069.5 4.25 1.519m-8.535 4.306c0 1.82.363 3.12 1.134 4.072.804 1.002 1.92 1.57 3.12 1.57 2.56 0 4.102-2.103 4.102-5.626 0-1.719-.345-3.021-1.034-3.921-.689-.885-1.806-1.402-3.086-1.402-2.642 0-4.236 1.985-4.236 5.307M127.063 12.752h.477c1.297 0 1.673-.4 1.673-1.736V2.671h-2.116v-.534h4.629l8.403 8.246V3.956c-.017-1.152-.312-1.334-2.118-1.285v-.534h4.235v.534c-.13-.016-.197-.016-.312-.016-.377 0-.82.134-.97.3-.228.234-.294.45-.294 1.068v9.747h-.426L129.739 3.305v7.711c0 1.402.328 1.736 1.69 1.736h.494l.015.518h-4.875v-.518zM19.43.706H.187v32.112h21.321V2.779A2.08 2.08 0 0 0 19.431.707' />
        </g>
        <path
          fill='#000E56'
          d='M6.003 23.495h10.914l-1.04 1.25-.006.007v2.162H7.13V24.76H6.004V28H17v-5.59H6.084l1.042-1.265.006-.008v-2.142h8.739v2.198H17v-3.284h-1.047L17 16.637v-4.799L7.128 7.21V6H6l.003 17.495zm6.052-6.85l.005-.008V10.73l3.81 1.787v5.392h-4.857l1.042-1.265zm-4.93 0l.007-.008v-8.02l-.001-.199 3.8 1.783v7.708H6.084l1.042-1.265z'
        />
      </g>
    </svg>
  );
}
export function DownArrow({ ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#FFF'
          d='M14 4.586l-6 6-6-6L.586 6l6.707 6.707a1 1 0 0 0 1.414 0L15.414 6 14 4.586z'
        />
      </g>
    </svg>
  );
}

export function DownCaret({ ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path fill='#B5B5B5' fillRule='nonzero' d='M8 11.4L2.6 6 4 4.6l4 4 4-4L13.4 6z' />
      </g>
    </svg>
  );
}

export function LeftArrow({ ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path d='M16 0H0v16h16z' />
        <path
          fill='#0827C7'
          d='M5.216 3.089l-.07.057-5 5-.011.013a.503.503 0 0 0-.033.039l.044-.052A.502.502 0 0 0 0 8.5v.02l.005.052L0 8.5a.502.502 0 0 0 .089.284l.013.018c.01.014.02.027.033.04l.011.012 5 5a.5.5 0 0 0 .765-.638l-.057-.07L1.707 9H15.5a.5.5 0 0 0 .09-.992L15.5 8H1.707l4.147-4.146a.5.5 0 0 0 .057-.638l-.057-.07a.5.5 0 0 0-.638-.057z'
        />
      </g>
    </svg>
  );
}
export function DownArrowBlue({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M0 0H24V24H0z'
                  transform='translate(-948 -3538) translate(360 3013) translate(529 466) translate(59 59)'
                />
                <g fill='#0827C7' strokeLinecap='round' strokeLinejoin='round'>
                  <path
                    d='M8 0c.513 0 .936.386.993.883L9 1v17.585l5.293-5.292c.36-.36.928-.388 1.32-.083l.094.083c.36.36.388.928.083 1.32l-.083.094-7 7c-.028.029-.059.055-.09.08l.09-.08c-.035.036-.073.068-.112.097-.024.018-.049.034-.074.05l-.037.021c-.02.011-.04.022-.06.031l-.053.023-.06.021-.045.014-.065.016-.053.009c-.02.003-.04.006-.062.007-.018.002-.035.003-.053.003L8 22h-.032l-.054-.004L8 22c-.05 0-.1-.004-.149-.011l-.052-.01c-.022-.004-.043-.009-.065-.015l-.046-.014-.06-.021-.051-.023-.061-.03-.037-.022c-.025-.016-.05-.032-.074-.05l-.018-.014c-.035-.028-.066-.054-.094-.083l-7-7c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083l.094.083L7 18.585V1c0-.552.448-1 1-1z'
                    transform='translate(-948 -3538) translate(360 3013) translate(529 466) translate(59 59) translate(4 1)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function RightBlueArrow({ ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#0827C7'
          d='M10.784 3.089l.07.057 5 5 .011.013a.503.503 0 0 1 .033.039l-.044-.052A.502.502 0 0 1 16 8.5v.02a.503.503 0 0 1-.005.052L16 8.5a.502.502 0 0 1-.089.284l-.013.018a.503.503 0 0 1-.033.04l-.011.012-5 5a.5.5 0 0 1-.765-.638l.057-.07L14.293 9H.5a.5.5 0 0 1-.09-.992L.5 8h13.793l-4.147-4.146a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057z'
        />
      </g>
    </svg>
  );
}

export function Circles() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='1024' height='345' viewBox='0 0 1024 345'>
      <defs>
        <path id='a' d='M0 0h1074v345H0z' />
        <linearGradient id='c' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
        <linearGradient id='d' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
        <linearGradient id='e' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
        <linearGradient id='f' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#FFF' stop-opacity='0' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd' transform='translate(-50)'>
        <mask id='b' fill='#fff'>
          <use />
        </mask>
        <use fill='#FFF' />
        <ellipse cx='562' cy='164' stroke='#DEDEDE' mask='url(#b)' rx='56.5' ry='57.5' />
        <ellipse cx='562' cy='164' stroke='#DEDEDE' mask='url(#b)' rx='282.5' ry='283.5' />
        <circle cx='562' cy='164' r='427.5' stroke='#DEDEDE' mask='url(#b)' />
        <ellipse cx='562' cy='164' stroke='#DEDEDE' mask='url(#b)' rx='158.5' ry='157.5' />
        <path fill='url(#c)' d='M79 0h292v70H79z' mask='url(#b)' />
        <path fill='url(#d)' d='M742 0h290v70H742z' mask='url(#b)' />
        <path
          fill='url(#e)'
          d='M742 280h290v71H742z'
          mask='url(#b)'
          transform='rotate(-180 887 315.5)'
        />
        <path
          fill='url(#f)'
          d='M79 280h292v71H79z'
          mask='url(#b)'
          transform='rotate(-180 225 315.5)'
        />
      </g>
    </svg>
  );
}
export function PhoneIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#FFF'
          d='M1.333 10.667v.666a3.337 3.337 0 0 0 3.334 3.334h.666V16h-.666A4.672 4.672 0 0 1 0 11.333v-.666h1.333zM5.171.848c.78-.78 2.049-.78 2.829 0L15.152 8c.78.78.78 2.049 0 2.829l-4.323 4.323c-.78.78-2.049.78-2.829 0L.848 8a2.002 2.002 0 0 1 0-2.829zm2.357 1.415a.666.666 0 0 0-.943 0L2.262 6.586a.666.666 0 0 0 0 .943l6.21 6.209c.26.26.681.26.942 0l4.323-4.323a.666.666 0 0 0 0-.943zM11.333 0A4.672 4.672 0 0 1 16 4.667v.666h-1.333v-.666a3.337 3.337 0 0 0-3.334-3.334h-.666V0h.666z'
        />
      </g>
    </svg>
  );
}
export function MobilePhoneIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill='#B5B5B5'
          fillRule='nonzero'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M18 0a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm1 19H5v2a1 1 0 0 0 .883.993L6 22h12a1 1 0 0 0 1-1v-2zM18 2H6a1 1 0 0 0-1 1v14h14V3a1 1 0 0 0-.883-.993L18 2z'
        />
      </g>
    </svg>
  );
}
export function LetterIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill='#B5B5B5'
          fillRule='nonzero'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M23 12a1 1 0 0 1 .993.883L24 13v6a3 3 0 0 1-2.824 2.995L21 22H3a3 3 0 0 1-2.995-2.824L0 19v-6a1 1 0 0 1 1.993-.117L2 13v6a1 1 0 0 0 .883.993L3 20h18a1 1 0 0 0 .993-.883L22 19v-6a1 1 0 0 1 1-1zM21 2a3 3 0 0 1 3 3v3a1 1 0 0 1-.521.878l-11 6a1 1 0 0 1-.958 0l-11-6A1 1 0 0 1 0 8V5a3 3 0 0 1 3-3zm0 2H3a1 1 0 0 0-1 1v2.407l10 5.454 10-5.455V5a1 1 0 0 0-.883-.993L21 4z'
        />
      </g>
    </svg>
  );
}
export function XIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill={fill}
          d='M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z'
        />
      </g>
    </svg>
  );
}
export function EmailIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M15.04 7.667c.492 0 .898.386.954.883l.006.117v4c0 1.235-.921 2.246-2.087 2.328L13.76 15H2.24c-1.186 0-2.156-.96-2.235-2.174L0 12.666v-4c0-.552.43-1 .96-1 .492 0 .898.387.954.884l.006.117v4c0 .16.11.295.256.326L2.24 13h11.52a.324.324 0 0 0 .313-.266l.007-.067v-4c0-.553.43-1 .96-1zM13.76 1C14.997 1 16 2.045 16 3.333v2c0 .366-.192.703-.5.878l-7.04 4a.926.926 0 0 1-.92 0l-7.04-4a1.007 1.007 0 0 1-.5-.878v-2C0 2.045 1.003 1 2.24 1zm0 2H2.24c-.177 0-.32.15-.32.333V4.74L8 8.194l6.08-3.455V3.333a.33.33 0 0 0-.256-.326L13.76 3z'
        />
      </g>
    </svg>
  );
}
export function OneIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 70 128'>
      <path fill='#E6F5EE' fillRule='nonzero' d='M69.791 128V.801H.4V29.2h36.111V128z' />
    </svg>
  );
}
export function TwoIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 142 131'>
      <path
        fill='#E6F5EE'
        fillRule='nonzero'
        d='M141.222 130.985v-25.6l-96.694 1.705 32.896-14.623c36.183-13.545 60.772-24.894 60.772-48.653C138.196 17.07 109.78.765 68.31.765 25.87.765-1.334 21.491.424 50.803h32.308c.491-14.183 14.817-23.309 36.459-23.309 24.11 0 34.673 8.343 34.673 20.321 0 21.914-34.56 30.964-98.957 59.97h-.005l-.026.014h.026v23.186h136.32z'
      />
    </svg>
  );
}
export function ThreeIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 138 163'>
      <path
        fill='#E6F5EE'
        fillRule='nonzero'
        d='M68.212 162.245c42.271 0 69.29-18.78 69.29-45.787 0-26.85-21.194-35.696-51.888-38.06 28.89-2.282 48.848-10.54 48.848-35.368 0-25.306-24.98-42.38-66.221-42.38C31.353.65.974 19.298 2.622 49.106h30.226c.389-13.178 15.04-21.83 35.393-21.83 21.074 0 33.52 7.958 33.52 21.053 0 14.21-11.239 22.584-38.623 22.584H42.59V88.24h20.548c26.112 0 41.29 8.486 41.29 23.808 0 15.763-13.02 23.671-36.216 23.671-20.395 0-36.72-9.058-36.98-23.011H.857c-1.649 29.22 26.014 49.536 67.356 49.536z'
      />
    </svg>
  );
}

export function ThreeMillionIcon() {
  return (
    <svg height='438' viewBox='0 0 576 438' width='576' xmlns='https://www.w3.org/2000/svg'>
      <linearGradient id='a'>
        <stop offset='0' stopColor='#fff' />
        <stop offset='1' stopColor='#dde5fc' />
      </linearGradient>
      <linearGradient id='b' x1='0%' y1='50%' y2='50%' />
      <linearGradient id='c' x1='0%' y1='49.994%' y2='49.994%' />
      <linearGradient id='d' x1='0%' y1='50.022%' y2='50.022%' />
      <linearGradient id='e' x1='-.158%' x2='100.158%' y1='50%' y2='50%'>
        <stop offset='0' stopColor='#ed5f40' />
        <stop offset='1' stopColor='#7685f5' />
      </linearGradient>
      <linearGradient id='f' x1='-.202%' x2='100.202%' y1='49.993%' y2='49.993%'>
        <stop offset='0' stopColor='#7685f5' />
        <stop offset='1' stopColor='#6bd0b1' />
      </linearGradient>
      <g fill='none' fillRule='evenodd'>
        <path
          d='m23.102 303.17 208.843 133.086 23.255 1.651 320.564-184.233-238.194-131.216z'
          fill='#bfc9dd'
          fillRule='nonzero'
          opacity='.3'
        />
        <g fillRule='nonzero'>
          <path d='m.444 292.699.028 8.999 231.9 134.945-.029-8.999z' fill='#efeff0' />
          <path d='m232.343 427.644.028 9 320.296-184.519-.023-8.999z' fill='#bfc9dd' />
          <path
            d='m.444 184.699 231.9 134.945 320.3-184.518-231.9-134.945z'
            fill='url(#b)'
            transform='translate(0 108)'
          />
        </g>
        <path
          d='m320.609 108-319.609 184.09 36.391 20.91 319.609-184.09z'
          fill='#f64621'
          fillRule='nonzero'
        />
        <path
          d='m37 313.815v9.185l-36.972-21.063-.028-8.937z'
          fill='#f64621'
          fillRule='nonzero'
          opacity='.7'
        />
        <path
          d='m81 339 320-185m-270 216 320-186m-272 212 320-185m-416 76 195 114m-147-140 195 114m-143-147 195 114m-150-138 195 114m-152-140 195 114m-154-138 195 114'
          stroke='#bfc9dd'
        />
        <path d='m36 292 48-27' stroke='#fff' strokeLinecap='round' strokeWidth='9' />
        <g fillRule='nonzero'>
          <path
            d='m399.85 16-45.85 26.268 51.888 29.732 46.112-26.422zm-45.85 27v138.281l51 29.719v-138.281z'
            fill='#86dab1'
          />
          <path d='m451 46v137.701l-45 26.299v-137.701z' fill='#48cba3' />
          <path d='m271.852 169-45.852 26.268 51.89 29.732 46.11-26.422z' fill='#3e6bf9' />
          <path d='m227 195v59.401l51 29.599v-59.401z' fill='#3e6bf9' />
          <path d='m324 199v58.913l-45 26.087v-58.913z' fill='#2021c5' />
          <g>
            <path
              d='m19.689 38.797-6.447-3.734 20.06-34.948 6.446 3.734z'
              fill='url(#c)'
              transform='translate(388)'
            />
            <path
              d='m6.632 40.32-6.447-3.734 3.895-6.73 6.448 3.74z'
              fill='url(#d)'
              transform='translate(388)'
            />
            <path
              d='m427.748 3.85 3.95 2.182-23.958 41.738-13.108-7.449 3.896-6.725 9.16 5.202z'
              fill='#a3b0c6'
            />
          </g>
          <path
            d='m429.922 124v1.962c.4-.172.833-.262 1.27-.264.35.003.69.119.967.328.289.241.5.558.61.913.161.49.236 1.002.22 1.515l-2.345 1.31c0-.72-.14-1.191-.413-1.4-.272-.21-.623-.188-1.069.063-.23.123-.442.276-.628.456-.173.17-.318.364-.432.575a2.478 2.478 0 0 0 -.248.648 2.49 2.49 0 0 0 -.08.667c-.007.19.021.38.085.561a.628.628 0 0 0 .276.347c.163.088.344.136.53.142.271.01.543-.003.811-.042.477-.055.956-.08 1.435-.077a2.61 2.61 0 0 1 1.107.233c.314.16.567.414.722.725.187.433.275.9.258 1.37 0 .527-.076 1.053-.225 1.56-.157.51-.375 1.001-.652 1.46a7.29 7.29 0 0 1 -1.013 1.315c-.4.415-.845.787-1.327 1.11v1.802l-1.285.721v-1.798c-.411.188-.849.317-1.299.383-.381.055-.77 0-1.12-.16a1.746 1.746 0 0 1 -.774-.853 4.099 4.099 0 0 1 -.3-1.702l2.345-1.315c-.015.335.036.67.15.986.074.195.22.358.408.456a.86.86 0 0 0 .572.042c.229-.058.448-.147.651-.265.243-.134.467-.298.666-.489.18-.18.338-.38.47-.597.122-.21.22-.431.29-.662.061-.22.093-.447.094-.676a1.647 1.647 0 0 0 -.094-.616.71.71 0 0 0 -.29-.36c-.16-.09-.341-.14-.526-.142-.26-.01-.521.006-.778.046-.479.069-.961.105-1.445.11a2.592 2.592 0 0 1 -1.116-.224 1.586 1.586 0 0 1 -.717-.717 3.12 3.12 0 0 1 -.263-1.369c0-.519.077-1.035.225-1.533a6.38 6.38 0 0 1 .643-1.47 8.094 8.094 0 0 1 1.008-1.333c.392-.42.832-.793 1.313-1.113v-1.935zm-128.012 108v2.06c.4-.18.83-.275 1.267-.28.351.005.69.129.966.351.292.252.506.586.615.96.16.514.234 1.05.22 1.59l-2.345 1.382c0-.763-.14-1.253-.408-1.474-.268-.22-.624-.197-1.074.067a2.741 2.741 0 0 0 -1.304 1.786 2.753 2.753 0 0 0 -.085.701 1.83 1.83 0 0 0 .085.595c.05.15.149.278.281.36.16.095.34.146.525.15.273.01.546-.002.817-.04.476-.061.955-.09 1.435-.086.382-.001.76.084 1.107.25.317.16.572.424.727.749.19.454.279.946.258 1.44a5.886 5.886 0 0 1 -.225 1.642 6.964 6.964 0 0 1 -.647 1.536 7.668 7.668 0 0 1 -1.018 1.382c-.397.448-.84.85-1.323 1.2v1.92l-1.285.759v-1.887c-.414.197-.853.331-1.304.399-.38.06-.768.002-1.117-.163a1.826 1.826 0 0 1 -.778-.903 4.411 4.411 0 0 1 -.296-1.79l2.345-1.383c-.013.354.04.708.155 1.042a.882.882 0 0 0 .408.48c.179.083.38.098.568.043a2.38 2.38 0 0 0 .657-.278c.242-.142.466-.315.666-.514.179-.191.336-.402.469-.629.125-.216.223-.449.29-.691.071-.235.11-.48.113-.725a1.962 1.962 0 0 0 -.094-.653.785.785 0 0 0 -.29-.38 1.12 1.12 0 0 0 -.526-.148 3.943 3.943 0 0 0 -.783.048c-.478.078-.961.116-1.445.115a2.479 2.479 0 0 1 -1.112-.23 1.64 1.64 0 0 1 -.717-.759 3.341 3.341 0 0 1 -.263-1.44 5.754 5.754 0 0 1 .225-1.617 6.951 6.951 0 0 1 .643-1.541 8.26 8.26 0 0 1 1.008-1.407c.393-.44.834-.833 1.314-1.171v-2.036l1.276-.782z'
            fill='#fff'
          />
          <path d='m125.85 282-45.85 26.273 51.888 29.727 46.112-26.417z' fill='#f64621' />
          <path d='m81 308v31.977l51 30.023v-31.981z' fill='#f64621' />
          <path d='m176 311v31.623l-45 26.377v-31.623z' fill='#f64621' />
          <path
            d='m154.917 329v2.067c.4-.185.835-.28 1.275-.279.351.001.692.123.968.346.29.254.502.588.611.961.162.514.237 1.052.221 1.591l-2.35 1.385c0-.765-.142-1.255-.414-1.476-.273-.221-.626-.197-1.073.067-.232.128-.444.29-.63.48a2.66 2.66 0 0 0 -.437.607 2.925 2.925 0 0 0 -.244.677c-.06.23-.086.469-.08.707-.008.2.021.4.084.591.048.151.146.28.278.365.162.093.345.143.531.144.272.014.544.002.814-.038.477-.058.958-.085 1.438-.082a2.53 2.53 0 0 1 1.11.245c.315.17.569.437.724.765.187.455.274.948.254 1.442a6.098 6.098 0 0 1 -.22 1.643 7.085 7.085 0 0 1 -.654 1.539c-.287.497-.628.96-1.016 1.379-.4.438-.847.83-1.33 1.168v1.899l-1.27.807v-1.894a4.808 4.808 0 0 1 -1.303.404c-.383.058-.774 0-1.124-.168a1.862 1.862 0 0 1 -.78-.899 4.53 4.53 0 0 1 -.297-1.798l2.352-1.384c-.012.355.04.708.155 1.043a.79.79 0 0 0 .382.476.76.76 0 0 0 .6.053c.23-.06.45-.153.654-.274a3.055 3.055 0 0 0 1.138-1.144c.123-.22.221-.454.292-.697a2.87 2.87 0 0 0 .094-.711c.008-.22-.024-.44-.094-.65a.777.777 0 0 0 -.292-.384 1.105 1.105 0 0 0 -.527-.144 3.622 3.622 0 0 0 -.785.048 9.48 9.48 0 0 1 -1.443.11 2.432 2.432 0 0 1 -1.12-.23 1.666 1.666 0 0 1 -.719-.76 3.327 3.327 0 0 1 -.263-1.441c0-.547.076-1.09.225-1.615a6.897 6.897 0 0 1 .645-1.548 8.462 8.462 0 0 1 1.01-1.408c.396-.44.837-.833 1.317-1.173v-2.033z'
            fill='#fff'
          />
        </g>
        <path d='m279 284v-58.913l45-26.087m-148 112-45 26.377v31.623' stroke='#fff' />
        <path d='m249 268-73 42' stroke='url(#e)' />
        <path d='m381 194-57 33' stroke='url(#f)' />
        <path
          d='m268 320.456c-9.155.297-18.766-5.717-30.223-16.619-20.342-19.385-38.047 13.31-48.979 42.478a234.505 234.505 0 0 0 -7.355 23.595c-1.725 6.664-5.329 17.17-11.443 20.09'
          stroke='#f64621'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m403 222.17c-9.63 5.037-21.767-3.768-42.126-23.722-21.165-20.754-40.95 57.476-61.943 93.58-11.466 19.715-21.395 28.622-31.931 28.972'
          stroke='#3e6bf9'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m481 94s-29.703 13.759-57.923 95.13c-6.467 18.659-12.127 29.292-19.077 32.87'
          stroke='#86dab1'
          strokeLinecap='round'
          strokeWidth='4'
        />
        <path
          d='m278 224-51-29m179 15v-137.701l45-26.299m-97-3 51 29m-324 236 51 29'
          stroke='#fff'
        />
      </g>
    </svg>
  );
}

export function ChartIcon() {
  return (
    <svg height='16' viewBox='0 0 16 16' width='16' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 0h16v16h-16z' />
        <path
          d='m8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm5.9 7h-2.1c-.3-1.4-1.4-2.5-2.8-2.9v-2c2.5.4 4.5 2.4 4.9 4.9zm-7.9 1c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm1-5.9v2.1c-1.7.4-3 1.9-3 3.8 0 .7.2 1.3.5 1.9l-1.5 1.4c-.6-1-1-2.1-1-3.3 0-3 2.2-5.4 5-5.9zm1 11.9c-1.4 0-2.6-.5-3.6-1.2l1.5-1.4c.6.4 1.3.6 2.1.6 1.9 0 3.4-1.3 3.9-3h2.1c-.6 2.8-3 5-6 5z'
          fill='#fff'
        />
      </g>
    </svg>
  );
}
export function CircleGraphicsIcon() {
  return (
    <svg height='434' viewBox='0 0 1351 434' width='1351' xmlns='https://www.w3.org/2000/svg'>
      <defs>
        <path id='a' d='m0 0h1351v434h-1351z' />
        <linearGradient id='b' x1='50%' x2='50%' y1='0%' y2='71.987%'>
          <stop offset='0' stopColor='#fff' />
          <stop offset='1' stopColor='#fff' stop-opacity='0' />
        </linearGradient>
        <mask id='c' fill='#fff'>
          <use fill='#fff' fillRule='evenodd' />
        </mask>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <use fill='#fff' />
        <g stroke='#dedede'>
          <circle cx='707' cy='207' mask='url(#c)' r='71.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='355.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='537.5' />
          <circle cx='707' cy='207' mask='url(#c)' r='199.5' />
        </g>
        <path d='m100 0h367v90h-367zm832 0h367v90h-367z' fill='url(#b)' mask='url(#c)' />
        <path
          d='m932 352h367v90h-367z'
          fill='url(#b)'
          mask='url(#c)'
          transform='matrix(-1 0 0 -1 2231 794)'
        />
        <path
          d='m100 352h367v90h-367z'
          fill='url(#b)'
          mask='url(#c)'
          transform='matrix(-1 0 0 -1 567 794)'
        />
      </g>
    </svg>
  );
}
export function CoinsIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M24 20c0 2.398-3.205 4-7 4-3.707 0-6.85-1.529-6.995-3.834L10 20l.002-.365C9.079 19.873 8.057 20 7 20 3.293 20 .15 18.471.005 16.166L0 16V4l.005-.166C.15 1.529 3.293 0 7 0c3.795 0 7 1.602 7 4v4c0 .125-.009.248-.026.369C14.894 8.129 15.924 8 17 8c3.795 0 7 1.602 7 4v-.003V20zm-7 0c-1.936 0-3.719-.417-5-1.144V20c0 .916 2.167 2 5 2 2.744 0 4.864-1.017 4.994-1.914L22 20v-1.144C20.72 19.583 18.937 20 17 20zm5-5.144C20.72 15.583 18.937 16 17 16s-3.718-.417-5-1.144V16c0 .916 2.167 2 5 2 2.744 0 4.864-1.017 4.994-1.914L22 16zM2 14.856L2 16c0 .916 2.167 2 5 2 1.098 0 2.138-.161 3.002-.449v-1.917C9.079 15.873 8.056 16 7 16c-1.937 0-3.72-.417-5.001-1.144zM10 11.997c0-.124.009-.246.026-.366l-.043.012C9.073 11.875 8.059 12 7 12c-1.936 0-3.719-.417-5-1.144V12c0 .916 2.167 2 5 2 1.097 0 2.137-.162 3.002-.45zM17 10c-2.832 0-5 1.084-5 2 0 .916 2.168 2 5 2s5-1.084 5-2c0-.916-2.168-2-5-2zm-5-3.144C10.72 7.583 8.937 8 7 8s-3.718-.417-5-1.144V8c0 .916 2.167 2 5 2 2.744 0 4.864-1.017 4.994-1.914L12 8zM7 2C4.168 2 2 3.084 2 4c0 .916 2.168 2 5 2s5-1.084 5-2c0-.916-2.168-2-5-2z'
        />
      </g>
    </svg>
  );
}
export function CraneIcon() {
  return (
    <svg height='25' viewBox='0 0 24 25' width='24' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 .77h24v24h-24z' />
        <path
          d='m9 1.69a1 1 0 0 1 .993.884l.007.116v1.946l13.068.897a1 1 0 0 1 .926.886l.006.111v2.88a1 1 0 0 1 -.883.994l-.117.006h-13v12.4h2a1 1 0 0 1 .117 1.994l-.117.006h-10a1 1 0 0 1 -.117-1.993l.117-.007h2v-12.4h-3a1 1 0 0 1 -.993-.883l-.007-.117v-2.88a1 1 0 0 1 .657-.939l.11-.033 3.233-.777v-2.09a1 1 0 0 1 .883-.994l.117-.007zm-1 2h-2v19.12h2zm12 7.6a1 1 0 0 1 .993.884l.007.116v3.8h2a1 1 0 0 1 .993.884l.007.116v3.84a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1-1v-3.84a1 1 0 0 1 1-1h2v-3.8a1 1 0 0 1 1-1zm2 6.8h-4v1.84h4zm-18-11.252-2 .48v1.092l2 .001zm6-.198v1.77h12v-.947z'
          fill='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
}
export function CSStudiesIcon() {
  return (
    <svg height='24' viewBox='0 0 24 24' width='24' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 0h24v24h-24z' />
        <g
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
          transform='translate(1 2)'
        >
          <path d='m22 17-4.172-4.172m-10.828-5.828h-7m7 6h-7m15 6h-15m15-18h-15' />
          <circle cx='15' cy='10' r='4' />
        </g>
      </g>
    </svg>
  );
}
export function DollarIcon() {
  return (
    <svg height='8' viewBox='0 0 8 8' width='8' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 0h8v8h-8z' />
        <path
          d='m4.5 3.6v-1.55c.3.1.5.4.5.7s.2.5.5.5.5-.2.5-.5c0-.9-.65-1.6-1.5-1.7v-.55c0-.3-.2-.5-.5-.5s-.5.2-.5.5v.55c-.85.1-1.5.8-1.5 1.7 0 1.05.8 1.45 1.5 1.65v1.55c-.3-.1-.5-.4-.5-.7s-.2-.5-.5-.5-.5.2-.5.5c0 .9.65 1.6 1.5 1.7v.55c0 .3.2.5.5.5s.5-.2.5-.5v-.55c.85-.1 1.5-.85 1.5-1.7 0-1.05-.8-1.45-1.5-1.65zm-1.5-.85c0-.35.2-.6.5-.7v1.3c-.35-.15-.5-.3-.5-.6zm1.5 3.2v-1.3c.35.15.5.3.5.6 0 .35-.2.6-.5.7z'
          fill='#fff'
        />
      </g>
    </svg>
  );
}
export function EngineersIcon() {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h32v32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M16 0a9 9 0 0 1 9 9c0 4.095-1.563 7.778-3.973 9.953l7.367 4.032a5.001 5.001 0 0 1 2.6 4.152l.006.238V31a1 1 0 0 1-.883.993L30 32H2a1 1 0 0 1-.993-.883L1 31v-3.625a5 5 0 0 1 2.399-4.27l.206-.12 7.368-4.032C8.563 16.778 7 13.095 7 9a9.11 9.11 0 0 1 .044-.9C7.496 3.552 11.334 0 16 0zm3.186 20.227A7.019 7.019 0 0 1 16 21a7.019 7.019 0 0 1-3.186-.773l-8.25 4.514a3.001 3.001 0 0 0-1.558 2.441L3 27.375V30h26v-2.625c0-1.033-.531-1.99-1.399-2.537l-.166-.098zM24 25a1 1 0 0 1 .117 1.993L24 27h-4a1 1 0 0 1-.117-1.993L20 25h4zM18.358 7.955l-.172.132c-1.568 1.155-3.63 1.842-5.836 1.908L12 10c-1.03 0-2.038-.135-2.988-.394C9.239 14.853 12.374 19 16 19c3.548 0 6.626-3.97 6.968-9.058-1.704-.193-3.274-.86-4.5-1.891l-.11-.096zM16 2a7.003 7.003 0 0 0-6.852 5.56c.89.288 1.855.44 2.852.44 2.292 0 4.382-.806 5.692-2.118a1 1 0 0 1 1.46.049c.912 1.042 2.252 1.754 3.763 1.987A7 7 0 0 0 16 2z'
        />
      </g>
    </svg>
  );
}

export function HouseIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d='M0 0H24V24H0z'
                    transform='translate(-176 -2148) translate(79 1900) translate(0 216) translate(81 16) translate(16 16)'
                  />
                  <g fill='#0827C7' strokeLinecap='round' strokeLinejoin='round'>
                    <path
                      d='M20.25 10.5c.385 0 .702.29.745.663l.005.087v10.5c0 .385-.29.702-.663.745l-.087.005H3.75c-.385 0-.702-.29-.745-.663L3 21.75v-10.5c0-.414.336-.75.75-.75.385 0 .702.29.745.663l.005.087V21h15v-9.75c0-.385.29-.702.663-.745l.087-.005zm-2.25 0V15l-1.72-1.72-3 3c-.27.27-.695.291-.99.063l-.07-.063-1.72-1.719-3.22 3.22c-.27.27-.695.29-.99.062l-.07-.063c-.27-.27-.291-.695-.063-.99l.063-.07 3.75-3.75c.27-.27.695-.291.99-.063l.07.063 1.72 1.719 2.469-2.47L13.5 10.5H18zM12.391.11l.078.054 11.25 9c.323.26.375.731.117 1.055-.24.298-.66.366-.977.17l-.078-.053L12 1.71 1.219 10.336c-.299.239-.724.212-.991-.048l-.064-.07c-.239-.298-.212-.723.048-.99l.07-.064 11.25-9c.248-.199.593-.217.86-.054z'
                      transform='translate(-176 -2148) translate(79 1900) translate(0 216) translate(81 16) translate(16 16) translate(0 .75)'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function HourGlassIcon({ ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h32v32H0z' />
        <path
          fill='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M27 1a1 1 0 0 1 .117 1.993L27 3h-1v3.279a7 7 0 0 1-.91 3.45l-.154.26L21.179 16l3.757 6.011a7 7 0 0 1 1.057 3.408l.007.302V29h1a1 1 0 0 1 .117 1.993L27 31H5a1 1 0 0 1-.117-1.993L5 29h.999L6 25.721a7 7 0 0 1 .91-3.45l.154-.26 3.756-6.012-3.756-6.01a7 7 0 0 1-1.057-3.408L6 6.28 5.999 3H5a1 1 0 0 1-.117-1.993L5 1h22zm-3 2H7.999L8 6.279a5 5 0 0 0 .618 2.408l.142.242 4.088 6.541a1 1 0 0 1 .06.949l-.06.111-4.088 6.541a5 5 0 0 0-.752 2.37L8 25.72 7.999 29H24v-3.279a5 5 0 0 0-.618-2.408l-.142-.242-4.088-6.541a1 1 0 0 1-.06-.949l.06-.111 4.088-6.541a5 5 0 0 0 .752-2.37L24 6.28V3zm-7.998 15.027a1 1 0 0 1 .85.473l3.848 6.161a2 2 0 0 1 .3 1.06V26H11v-.279a2 2 0 0 1 .3-1.059l3.852-6.162a1 1 0 0 1 .85-.473z'
        />
      </g>
    </svg>
  );
}
export function HourGlassIconBlue({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d='M0 0H32V32H0z'
                    transform='translate(-976 -2010) translate(170 1938) translate(750) translate(32 48) translate(24 24)'
                  />
                  <g fill='#0827C7' strokeLinecap='round' strokeLinejoin='round'>
                    <path
                      d='M23 0c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L23 2h-1v3.279c0 1.211-.314 2.4-.91 3.45l-.154.26L17.179 15l3.757 6.011c.642 1.027 1.005 2.201 1.057 3.408l.007.302V28h1c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L23 30H1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L1 28h.999L2 24.721c0-1.211.314-2.4.91-3.45l.154-.26 3.756-6.012-3.756-6.01c-.642-1.027-1.005-2.201-1.057-3.408L2 5.28 1.999 2H1c-.552 0-1-.448-1-1C0 .487.386.064.883.007L1 0h22zm-3 2H3.999L4 5.279c0 .843.213 1.672.618 2.408l.142.242 4.088 6.541c.18.288.2.645.06.949l-.06.111-4.088 6.541c-.447.715-.705 1.53-.752 2.37L4 24.72 3.999 28H20v-3.279c0-.843-.213-1.672-.618-2.408l-.142-.242-4.088-6.541c-.18-.288-.2-.645-.06-.949l.06-.111 4.088-6.541c.447-.715.705-1.53.752-2.37L20 5.28V2zm-7.998 15.027c.346 0 .668.179.85.473l3.848 6.161c.197.318.301.686.3 1.06V25H7v-.279c-.001-.374.103-.741.3-1.059l3.852-6.162c.182-.294.504-.473.85-.473z'
                      transform='translate(-976 -2010) translate(170 1938) translate(750) translate(32 48) translate(24 24) translate(4 1)'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function HousePricingIcon() {
  return (
    <svg height='24' viewBox='0 0 24 24' width='24' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 0h24v24h-24z' />
        <g strokeLinecap='round' strokeLinejoin='round'>
          <path d='m1 11 11-9 11 9m-19 2v10h16v-10' stroke='#fff' strokeWidth='2' />
          <path d='m8 17 2-2 2 2 3-3' stroke='#fff' strokeWidth='2' />
          <path d='m12 12h5v5z' fill='#fff' fillRule='nonzero' />
        </g>
      </g>
    </svg>
  );
}
export function PulseIcon() {
  return (
    <svg height='16' viewBox='0 0 16 16' width='16' xmlns='https://www.w3.org/2000/svg'>
      <g fill='none' fillRule='evenodd'>
        <path d='m0 0h16v16h-16z' />
        <path
          d='m8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3 0-5.4-2.2-5.9-5h3.3l1.5-1.5 3 4 2.5-2.5h1.5c-.5 2.8-2.9 5-5.9 5zm3.6-7-1.5 1.5-3-4-2.5 2.5h-2.5c.5-2.8 2.9-5 5.9-5s5.4 2.2 5.9 5z'
          fill='#fff'
        />
      </g>
    </svg>
  );
}

export function SmallPhone({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='10' height='15' viewBox='0 0 10 15' {...props}>
      <path
        fill={fill}
        d='M7.125 14.063c.469 0 .879-.108 1.23-.323l.03-.058c.058 0 .42-.166 1.084-.498.254-.137.312-.342.176-.616L7.916 9.141c-.117-.254-.303-.332-.557-.235l-.38.176c-.352.195-.586.322-.704.38-.058 0-.166-.067-.322-.204-.156-.137-.337-.357-.542-.66-.205-.302-.395-.649-.571-1.04-.43-1.015-.557-1.61-.381-1.787l1.025-.527c.079-.02.157-.107.235-.264 0-.195-.02-.322-.059-.38L3.932 1.172c-.02-.078-.127-.156-.323-.234-.117 0-.214.019-.293.058-.02 0-.19.083-.512.25-.323.165-.493.248-.513.248l-.03.059c-.253.117-.458.239-.615.366-.156.127-.341.376-.556.747-.215.371-.327.806-.337 1.304-.01.498.112 1.2.366 2.11.254.907.664 1.928 1.23 3.06 1.622 3.282 3.213 4.922 4.776 4.922zm0-.938c-1.172 0-2.48-1.465-3.926-4.395l-.184-.368c-.414-.847-.724-1.608-.93-2.283-.233-.771-.36-1.367-.38-1.787-.02-.42.044-.781.19-1.084.147-.303.274-.498.381-.586.108-.088.26-.18.454-.278l.586-.293 1.319 2.578-.615.351c-.547.274-.684.909-.41 1.905.195.761.556 1.538 1.083 2.329.528.79 1.075 1.186 1.641 1.186.137 0 .264-.029.38-.088 0-.019.03-.043.089-.073.058-.029.141-.068.249-.117.107-.049.19-.093.249-.132l1.318 2.578c-.078.02-.166.054-.264.103l-.234.117c-.059.03-.098.044-.117.044l-.03.059c-.41.156-.693.234-.849.234z'
      />
    </svg>
  );
}

export function CirclePhone({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='89' height='89' viewBox='0 0 89 89'>
      <defs>
        <filter
          id='prefix__a'
          width='514.8%'
          height='514.8%'
          x='-207.4%'
          y='-137%'
          filterUnits='objectBoundingBox'
        >
          <feMorphology in='SourceAlpha' radius='2.5' result='shadowSpreadOuter1' />
          <feOffset dy='19' in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
          <feGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='18' />
          <feColorMatrix in='shadowBlurOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0' />
        </filter>
        <path
          id='prefix__b'
          d='M13.5 0C20.956 0 27 6.044 27 13.5S20.956 27 13.5 27 0 20.956 0 13.5 6.044 0 13.5 0z'
        />
      </defs>
      <path
        fill='#fff'
        d='M7.125 14.063c.469 0 .879-.108 1.23-.323l.03-.058c.058 0 .42-.166 1.084-.498.254-.137.312-.342.176-.616L7.916 9.141c-.117-.254-.303-.332-.557-.235l-.38.176c-.352.195-.586.322-.704.38-.058 0-.166-.067-.322-.204-.156-.137-.337-.357-.542-.66-.205-.302-.395-.649-.571-1.04-.43-1.015-.557-1.61-.381-1.787l1.025-.527c.079-.02.157-.107.235-.264 0-.195-.02-.322-.059-.38L3.932 1.172c-.02-.078-.127-.156-.323-.234-.117 0-.214.019-.293.058-.02 0-.19.083-.512.25-.323.165-.493.248-.513.248l-.03.059c-.253.117-.458.239-.615.366-.156.127-.341.376-.556.747-.215.371-.327.806-.337 1.304-.01.498.112 1.2.366 2.11.254.907.664 1.928 1.23 3.06 1.622 3.282 3.213 4.922 4.776 4.922zm0-.938c-1.172 0-2.48-1.465-3.926-4.395l-.184-.368c-.414-.847-.724-1.608-.93-2.283-.233-.771-.36-1.367-.38-1.787-.02-.42.044-.781.19-1.084.147-.303.274-.498.381-.586.108-.088.26-.18.454-.278l.586-.293 1.319 2.578-.615.351c-.547.274-.684.909-.41 1.905.195.761.556 1.538 1.083 2.329.528.79 1.075 1.186 1.641 1.186.137 0 .264-.029.38-.088 0-.019.03-.043.089-.073.058-.029.141-.068.249-.117.107-.049.19-.093.249-.132l1.318 2.578c-.078.02-.166.054-.264.103l-.234.117c-.059.03-.098.044-.117.044l-.03.059c-.41.156-.693.234-.849.234z'
      />
    </svg>
  );
}

export function SecurityIcon({ fill = 'currentColor' }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill={fill}
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12 1h.04l.043.003L12 1a1.007 1.007 0 0 1 .548.163C15.198 2.93 18.942 4 22 4a1 1 0 0 1 1 1c0 8.102-3.719 14.967-10.606 17.92a1.001 1.001 0 0 1-.788 0l.098.036a.992.992 0 0 1-.075-.027l-.023-.01C4.72 19.967 1 13.102 1 5a1 1 0 0 1 1-1c3.058 0 6.802-1.07 9.445-2.832A1.008 1.008 0 0 1 12 1zM4.518 13.001c1.33 3.165 3.518 5.74 6.482 7.395V13zm14.964 0L13 13l.001 7.395c2.964-1.655 5.15-4.229 6.481-7.394zm1.252-7.051c-2.563-.2-5.365-.98-7.734-2.205V11h7.187c.404-1.397.66-2.883.762-4.435l.023-.393.007-.207zm-9.733-2.206C8.632 4.97 5.83 5.751 3.266 5.95l-.246.015.008.207c.083 1.694.347 3.314.785 4.829L11 11z'
        />
      </g>
    </svg>
  );
}
export function TeamIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill={fill}
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12 9a5 5 0 0 1 5 5v1c0 1-.294 1.932-.802 2.715l1.984.847a3 3 0 0 1 1.811 2.558l.007.199V23a1 1 0 0 1-.883.993L19 24H5a1 1 0 0 1-.993-.883L4 23v-1.681c0-1.133.638-2.163 1.637-2.673l.18-.085 1.981-.85A4.976 4.976 0 0 1 7 15v-1a5.005 5.005 0 0 1 4.776-4.995zM9.33 19.228l-2.723 1.17c-.331.143-.558.45-.6.802L6 21.32V22h12v-.681a1 1 0 0 0-.499-.865l-.106-.053-2.737-1.17a5.024 5.024 0 0 1-2.434.764L12 20a4.976 4.976 0 0 1-2.67-.772zM12 11l-.15.004A3 3 0 0 0 9 14v1a3.004 3.004 0 0 0 1.123 2.342 2.934 2.934 0 0 0 1.852.658l.176-.004A3 3 0 0 0 15 15v-1a3 3 0 0 0-3-3zm9-6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM3 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm18 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'
        />
      </g>
    </svg>
  );
}
export function GoldIcon({ stroke = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          d='M10 15H4l-2 6h10zm10 0h-6l-2 6h10zm-5-6H9l-2 6h10zM1 12h3m.2-7.8l2.1 2.1M12 1v3m7.8.2l-2.1 2.1M23 12h-3'
          stroke={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </g>
    </svg>
  );
}
export function WalletIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h24v24H0z' />
        <path
          fill={fill}
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M17 0a1 1 0 0 1 .993.883L18 1v1a1 1 0 0 1-1.993.117L16 2H3a1 1 0 0 0-.117 1.993L3 4h18a1 1 0 0 1 .993.883L22 5v6h1a1 1 0 0 1 .993.883L24 12v4a1 1 0 0 1-1 1h-1v6a1 1 0 0 1-.883.993L21 24H4a4 4 0 0 1-3.995-3.8L0 20V3l.001-.027.004-.15A3 3 0 0 1 2.824.006L3 0h14zM2 5.829V20a2 2 0 0 0 1.85 1.995L4 22h16v-5h-2a3.004 3.004 0 0 1-2.976-2.638l-.018-.176L15 14a3 3 0 0 1 3-3h2V6H3c-.062 0-.124-.002-.185-.006L3 6a3.039 3.039 0 0 1-.852-.123L2 5.83zM22 13h-4a1 1 0 0 0-.994.854l-.007.11.004.112A1 1 0 0 0 18 15h4v-2z'
        />
      </g>
    </svg>
  );
}
export function SmallXIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 11 11'>
      <path d='M2.176 10.7c.18-.286.41-.614.691-.986.282-.371.587-.762.917-1.171.33-.41.67-.82 1.024-1.229.353-.41.692-.795 1.015-1.157.323.362.662.748 1.015 1.157.354.41.695.82 1.024 1.229.33.41.635.8.917 1.171.281.372.512.7.691.986h1.33c-.551-.867-1.198-1.74-1.94-2.621-.743-.881-1.504-1.76-2.282-2.636L10.584.8H9.22l-3.36 3.986L2.499.8H1.098l4.006 4.671c-.766.867-1.52 1.739-2.264 2.615C2.098 8.962 1.451 9.833.9 10.7h1.276z' />
    </svg>
  );
}

export function DownCaretIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0h16v16H0z' />
        <path
          fill={fill}
          fillRule='nonzero'
          d='M14 4.586l-6 6-6-6L.586 6l6.707 6.707a1 1 0 0 0 1.414 0L15.414 6 14 4.586z'
        />
      </g>
    </svg>
  );
}

export function NoBypassIcon() {
  return (
    <svg height='637' viewBox='0 0 351 637' width='351' xmlns='https://www.w3.org/2000/svg'>
      <linearGradient id='a' x1='25.685%' x2='73.612%' y1='29.807%' y2='72.621%'>
        <stop offset='0' stopColor='#365cf5' />
        <stop offset='.07' stopColor='#4f70f6' />
        <stop offset='.25' stopColor='#849bf9' />
        <stop offset='.42' stopColor='#b0bffb' />
        <stop offset='.58' stopColor='#d2dbfd' />
        <stop offset='.74' stopColor='#ebeffe' />
        <stop offset='.88' stopColor='#fafbff' />
        <stop offset='.99' stopColor='#fff' />
      </linearGradient>
      <linearGradient id='b'>
        <stop offset='0' stopColor='#dde5fc' />
        <stop offset='1' stopColor='#fff' />
      </linearGradient>
      <linearGradient id='c' x1='.003%' x2='100.082%' y1='49.998%' y2='49.998%' />
      <linearGradient id='d' x1='.005%' x2='100.038%' y1='49.995%' y2='49.995%' />
      <linearGradient id='e' x1='.002%' x2='100.028%' y1='50%' y2='50%' />
      <g fill='none' fillRule='evenodd' opacity='.9'>
        <g fillRule='nonzero'>
          <path
            d='m334.608 164.307-307.408-164.077-17.888 8.492a16.291 16.291 0 0 0 -9.31 14.377 16.287 16.287 0 0 0 8.711 14.746l276.498 148.864z'
            fill='url(#a)'
            opacity='.1'
            transform='translate(16 450)'
          />
          <path
            d='m45.315 230.405s7.394-2.007 10.815 2.914c3.42 4.922 8.87 52.114 8.87 52.114s-.375 36.203-14.618 36.567c0 .016-19.486-86.658-5.067-91.595zm-33.456 229.668s-2.55 17.77 1.139 22.788c3.69 5.02 16.427 8.076 14.87.897-1.555-7.18-2.83-24.758-2.83-24.758l-13.18 1.073zm26.958-12.959-.817 12.246 9.113 4.404 2.58-1.231s11.98 8.114 25.307 2.47v-2.61s-19.86-6.611-23.943-13.767c-4.082-7.156-12.24-1.512-12.24-1.512z'
            fill='#281de2'
          />
          <path
            d='m9.188 316.343v80.67s-3.386 39.43 1.274 62.54c0 0 8.596 10.007 17.372 0l-.909-50.94 5.67-48.22s1.28 25.742 0 35.35c-1.282 9.606 4.752 53.293 4.752 53.293a30.765 30.765 0 0 0 16.455 1.27v-72.054l2.198-68.252s-17.1 7.521-46.812 6.343z'
            fill='#281de2'
          />
          <path
            d='m7.918 315.652s18.277 9.981 31.903 2.672c7.022-3.762 11.44-6.097 14.075-7.47a5.366 5.366 0 0 0 2.866-5.475c-1.12-8.562-3.337-29.615.525-38.583 4.913-11.387 5.454-46.376-18.54-47.727-23.992-1.352-38.747 17.66-38.747 17.66l6.28 42.037z'
            fill='#281de2'
          />
          <path d='m64.64 310 5.911.426 1.449 14.574-10-4.698z' fill='#f2cae7' />
          <path
            d='m20 222.889 4.444 8.545a49.097 49.097 0 0 1 5.503 20.748l2.679 68.818s9.9-3.679 14.237-5.91l3.07-64.587a61.234 61.234 0 0 0 -2.748-21.215l-2.701-8.599s-9.257-4.997-24.484 2.2z'
            fill='#fff'
          />
          <path
            d='m195.405 389 2.351 65.958s4.218 8.306 3.035 69.984c0 0-7.275 5.614-11.97-1.703l-16.893-80.376-2.928-40.365s17.962-4.01 26.405-13.498z'
            fill='#281de2'
          />
          <path
            d='m141 398.505 18.243 143.067s10.088 5.463 12.237 0c2.15-5.463 1.444-117.166 1.444-117.166s19.919-17.111 22.076-35.406c0 0-24.474 24.003-54 9.505z'
            fill='#281de2'
          />
          <path
            d='m170.306 541.874s1.562 10.696 0 12.597c-1.562 1.9-25.563 3.062-27.861-2.975-2.299-6.038 4.908-8.347 8.047-7.441s8.516-3.055 8.516-3.055 9.944 2.165 11.298.874zm19.264-17.468s-8.051-3.481-8.524.513c-.472 3.994 2.75 8.434 6.049 10.733 3.298 2.298 9.24 8.36 13.81 5.675 4.571-2.685.237-15.873.237-15.873s-4.624 4.5-11.572-1.048z'
            fill='#281de2'
          />
          <path
            d='m140.714 397.876s-5.784-69.136 3.899-76.003 41.92-24.168 46.294-11.154c4.374 13.015-2.9 46.882 4.093 77.665-.031.023-19.56 25.117-54.286 9.492z'
            fill='#4acea5'
          />
          <path d='m140.553 386s13.947-8.159 16.447-35l-17 28z' fill='#281de2' opacity='.5' />
          <path
            d='m99.411 284.315-25.881 14.297c-2.412 1.336-3.785 3.96-3.49 6.671l4.682 43.416c.096.858.62 1.611 1.397 2.01a2.657 2.657 0 0 0 2.472-.028l25.874-14.304c2.413-1.332 3.789-3.953 3.497-6.664l-4.696-43.415a2.577 2.577 0 0 0 -1.39-2.005 2.65 2.65 0 0 0 -2.464.022z'
            fill='url(#c)'
          />
          <path
            d='m136.738 141.55-42.881 24.328c-3.997 2.274-6.274 6.733-5.794 11.346l7.775 73.848a4.4 4.4 0 0 0 2.33 3.439 4.305 4.305 0 0 0 4.121-.073l42.874-24.32c3.993-2.275 6.263-6.737 5.77-11.346l-7.774-73.848a4.392 4.392 0 0 0 -2.316-3.43 4.297 4.297 0 0 0 -4.105.056z'
            fill='url(#d)'
          />
          <path
            d='m232.027.857-66.003 37.123a17.694 17.694 0 0 0 -8.923 17.319l11.974 112.701a6.711 6.711 0 0 0 3.583 5.251 6.676 6.676 0 0 0 6.344-.108l66.003-37.122a17.694 17.694 0 0 0 8.892-17.319l-11.943-112.702a6.711 6.711 0 0 0 -3.584-5.251 6.676 6.676 0 0 0 -6.344.108z'
            fill='url(#e)'
          />
          <path
            d='m188 308 16.478 10.992c5.878 3.586 8.154 11.054 5.29 17.355l-17.038 38.653-3.25-24.182 5.456-15.76-2.607-2.975zm-44.673 18-16.824 36.275-16.132-9.435c-7.482-4.37-8.704 6.201-8.304 6.59 11.469 11.06 25.596 23.156 28.976 23.484 6.061.595 11.761-1.647 18.652-14.743 6.89-13.096 13.305-35.032 13.305-35.032z'
            fill='#4acea5'
          />
          <path
            d='m110 352.206s-10.478-13.66-11.902-11.694.832 5.371.832 5.371-10.832-7.942-12.857-5.37c-.893 1.132 6.52 9.436 15.605 18.487-.4-.401.824-11.3 8.322-6.794zm46.012-35.221v-9.06s-9.384 2.886-9.899-5.782c-.514-8.667.56-23.154 6.614-27.322s24.216-1.443 20.864 10.898a65.04 65.04 0 0 0 -1.514 24.042s-4.215 7.618-16.065 7.224z'
            fill='#f2cae7'
          />
          <path
            d='m158.558 262.66a5.545 5.545 0 0 0 -5.18-.036 5.637 5.637 0 0 0 -2.985 4.271c-.635 4.72-1.033 12.549 3.21 13.374 6.117 1.18.65 11.73 3.907 12.163 3.257.432.65-4.813 3.25-3.895 2.599.918 1.528 9.317-2.86 12.996s10.023 7.874 17.699 0c7.675-7.875 10.795-26.648 6.376-22.845-4.42 3.802-5.352-15.094-11.063-11.022-3.608 2.56-7.981-2.583-12.354-5.005z'
            fill='#281de2'
          />
        </g>
        <path
          d='m75 306 24-14m-24 21 14-8m16-128 24-14m-24 24 24-14m-23 24 14-8'
          stroke='#a9b3ce'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m134.484 191.413-28.626 15.887c-2.688 1.6-4.182 4.684-3.798 7.838l1.036 13.216a3.008 3.008 0 0 0 1.616 2.332c.89.45 1.94.413 2.796-.099l28.634-15.904c2.687-1.602 4.18-4.684 3.799-7.838l-1.036-13.223a3.015 3.015 0 0 0 -1.63-2.316 2.9 2.9 0 0 0 -2.79.106z'
          fill='#fff'
          fillRule='nonzero'
        />
        <path
          d='m114.06 208.917s-2.647 13.047-4.693 12.026c-2.047-1.02 5.016-9.824 7.693-5.986 2.677 3.837 13.724-12.564 10-9.364-3.723 3.2-1.93 8.965 4.732 1.796 6.662-7.168 8.208-11.389 8.208-11.389'
          stroke='#a9b3ce'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='m222.601 27.574-42.968 24.632c-4.77 2.324-7.06 6.817-6.567 11.487l9.6 84.322a4.455 4.455 0 0 0 2.334 3.488 4.28 4.28 0 0 0 4.135-.072l42.991-24.632c4.012-2.297 6.296-6.816 5.809-11.487l-9.623-84.337c-.334-3.168-3.74-4.965-5.71-3.4z'
          fill='#fff'
          fillRule='nonzero'
        />
        <path
          d='m180 78 44-24m-42 34 25-14'
          stroke='#a9b3ce'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path d='m186 128 13-8' stroke='#4acea5' strokeLinecap='round' strokeWidth='2' />
        <path d='m185 50 31-18' stroke='#a9b3ce' strokeLinecap='round' strokeWidth='4' />
        <path
          d='m179.488 195.368c1.381-.853 2.504-.18 2.512 1.56-.097 1.912-1.021 3.659-2.488 4.706-1.381.852-2.504.17-2.512-1.56.097-1.912 1.021-3.66 2.488-4.706z'
          fill='#f74720'
          fillRule='nonzero'
        />
        <path
          d='m74.492 226.366c1.383-.852 2.508-.17 2.508 1.56-.09 1.916-1.017 3.667-2.492 4.708-1.375.852-2.5.17-2.508-1.56.097-1.913 1.023-3.66 2.492-4.708z'
          fill='#281de2'
          fillRule='nonzero'
        />
        <path
          d='m121.492 278.366c1.383-.852 2.5-.17 2.508 1.56-.09 1.915-1.017 3.665-2.492 4.706-1.383.853-2.508.18-2.508-1.56.09-1.914 1.017-3.665 2.492-4.706z'
          fill='#4acea5'
          fillRule='nonzero'
        />
        <path
          d='m116.492 121.366c1.375-.852 2.5-.17 2.508 1.558-.097 1.913-1.022 3.66-2.492 4.71-1.383.852-2.508.17-2.508-1.558.087-1.916 1.015-3.669 2.492-4.71z'
          fill='#e7c840'
          fillRule='nonzero'
        />
        <path
          d='m41.106 231.916c.07 0 .138-.147.138-.147l.382-8.8 3.002-1.2c8.619-3.518 2.178-23.076.184-32.758-3.178-15.466-21.851-13.471-28.704-1.26-4.753 8.468 7.326 24.159 7.326 24.159l.107 12.056s7.42 8.994 17.565 7.95z'
          fill='#f2cae7'
          fillRule='nonzero'
        />
        <path
          d='m34.237 194.758s19.192.238 13.811-10.745c-5.512-11.23-23.588-5.604-23.588-5.604s-12.851 4.337-10.064 16.687 8.624 15.904 8.624 15.904a5.339 5.339 0 0 0 1.115-5.373c-.612-1.873-1-4.053.317-4.513 2.4-.83 3.236 3.838 3.236 3.838l2.833-.353-3.096-13.049zm-33.509 41.897c-1.984 1.867-1.134 47.478 18.514 64.323 19.647 16.846 42.007 19.022 42.007 19.022l2.751-10.123-35.448-23.065s-10.2-66.77-27.824-50.157z'
          fill='#281de2'
          fillRule='nonzero'
        />
        <path
          d='m7 282s7.822 26.225 40 35c0 0-32.432-1.932-39.537-24.555z'
          fill='#281de2'
          fillRule='nonzero'
          opacity='.1'
        />
        <path
          d='m36.358 237 4.642-6.27-17.517-11.73-2.483 3.276zm4.642-6.428 3 4.428-.683-14-1.9.702z'
          fill='#ecf0fd'
          fillRule='nonzero'
        />
        <path
          d='m40.727 232-4.727 5.994 3.136 2.426-1.89 52.591 7.754 4.989-3.428-57.45 1.922-4.19z'
          fill='#4acea5'
          fillRule='nonzero'
        />
      </g>
    </svg>
  );
}
export function SafetyIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 30 38'
      {...props}
    >
      <g fill='none' fillRule='evenodd' stroke='#FFF' strokeLinejoin='round' strokeWidth='1.392'>
        <path
          d='M14.256.232c4.722 2.58 9.232 5.355 14.023 4.621L26.721 23.34c-2.597 7.407-8.633 7.88-12.465 12.324-3.833-4.444-9.869-4.917-12.466-12.324L.232 4.853c4.791.734 9.301-2.041 14.024-4.621z'
          transform='translate(1 1)'
        />
        <path
          strokeLinecap='round'
          d='M6.139 15.488c3.46 3.234 5.012 6.886 6.44 9.838 1.364-2.931 6.493-9.303 11.27-14.757'
          transform='translate(1 1)'
        />
      </g>
    </svg>
  );
}

export function Ribbon({ fill = 'currentColor', ...props }) {
  return (
    <svg xmlns='https://www.w3.org/2000/svg' width='32' height='69' viewBox='0 0 32 69' {...props}>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#0827C7'
          d='M4 0h24c2.21 0 4 1.79 4 4v62.743c0 1.104-.895 2-2 2-.571 0-1.115-.244-1.494-.67L15.987 54 3.495 68.065c-.733.825-1.997.9-2.823.167-.427-.38-.672-.924-.672-1.496V4c0-2.21 1.79-4 4-4z'
        />
        <g>
          <path d='M0 0H16V16H0z' transform='translate(8 24)' />
          <path
            fill='#FFF'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M13.333 0c.342 0 .624.257.663.589L14 .667v10c0 .368-.298.666-.667.666-.342 0-.623-.257-.662-.589l-.004-.077V1.333h-10v12.334c0 .52.396.947.903.995l.062.003.029-.003c.106-.018.253-.058.404-.127l.114-.057c.321-.176.488-.418.488-.811v-1c0-.369.298-.667.666-.667h10c.369 0 .667.298.667.667v1C16 14.956 14.956 16 13.667 16h-10c-1.246 0-2.264-.976-2.33-2.205l-.004-.128v-13c0-.342.258-.624.59-.663L2 0h11.333zm1.334 13.333H6v.334c0 .357-.07.676-.196.956l-.023.044h7.886c.52 0 .947-.397.995-.904l.005-.096v-.334zM10 8.667c.368 0 .667.298.667.666 0 .342-.258.624-.59.663L10 10H5.333c-.368 0-.666-.298-.666-.667 0-.342.257-.623.589-.662l.077-.004H10zM10 6c.368 0 .667.298.667.667 0 .342-.258.623-.59.662L10 7.333H5.333c-.368 0-.666-.298-.666-.666 0-.342.257-.624.589-.663L5.333 6H10zm0-2.667c.368 0 .667.299.667.667 0 .342-.258.624-.59.662L10 4.667H5.333c-.368 0-.666-.299-.666-.667 0-.342.257-.624.589-.662l.077-.005H10z'
            transform='translate(8 24)'
          />
        </g>
      </g>
    </svg>
  );
}
export function TimeIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='none'
        fillRule='evenodd'
        stroke='#FFF'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.392'
        d='M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15zM16 6.455V16 6.455zm6.818 16.363L16 16l6.818 6.818z'
      />
    </svg>
  );
}
export function PersonIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 36 37'
      {...props}
    >
      <path
        fill='none'
        fillRule='evenodd'
        stroke='#FFF'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.392'
        d='M24.21 9.596c0 3.573-3.086 6.434-6.766 6.116-3.262-.28-5.654-3.196-5.654-6.434v-1.82c0-3.238 2.392-6.154 5.654-6.434 3.68-.317 6.766 2.543 6.766 6.117v2.455zm-2.943 11.801L19.19 23.85c-.62.733-1.76.733-2.38 0l-2.077-2.452c-.865-1.021-2.313-1.41-3.548-.879-5.537 2.385-9.548 7.585-10.177 13.774C.916 35.202 1.635 36 2.56 36h30.88c.925 0 1.644-.798 1.552-1.708-.63-6.19-4.64-11.39-10.177-13.774-1.235-.532-2.683-.142-3.548.88z'
      />
    </svg>
  );
}
export function CarIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 41 31'
      {...props}
    >
      <g fill='none' fillRule='evenodd' stroke='#FFF' strokeLinejoin='round' strokeWidth='1.253'>
        <path
          d='M33.986 9.254c-9.664 1.027-20.42.937-28.909 0m28.909 15.518v2.607c0 .96-.762 1.738-1.701 1.738h-1.7c-.94 0-1.7-.778-1.7-1.738v-4.345M5.076 24.772v2.607c0 .96.762 1.738 1.7 1.738h1.701c.94 0 1.701-.778 1.701-1.738v-4.345'
          transform='translate(1 1)'
        />
        <path
          strokeLinecap='round'
          d='M13.58 19.38h11.903m-15.304 0H6.502c-.787 0-1.425-1.58-1.425-2.942m23.807 2.942h3.677c.787 0 1.425-1.58 1.425-2.942'
          transform='translate(1 1)'
        />
        <path
          d='M4.409 11.266h-2.52c-.777 0-1.68-.857-1.68-1.913 0-1.305 0-2.653 1.68-2.653h4.2m28.56 4.566h2.657c.777 0 1.68-.857 1.68-1.913 0-1.305 0-2.653-1.68-2.653h-4.337'
          transform='translate(1 1)'
        />
        <path
          strokeLinecap='round'
          d='M37.231 15.91c0-1.195-.414-2.338-1.151-3.267-1.83-2.306-3.907-5.577-4.532-9.539C31.1.442 27.596.209 24.87.209H14.194c-2.727 0-6.231.233-6.68 2.895-.313 3.235-2.713 7.252-4.547 9.56-.733.921-1.135 2.059-1.135 3.245v6.5c0 1.016 1.715 1.84 2.742 1.84h29.915c1.027 0 2.742-.824 2.742-1.84v-6.5z'
          transform='translate(1 1)'
        />
      </g>
    </svg>
  );
}
export function BigRibbon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='https://www.w3.org/2000/svg'
      width='48'
      height='102'
      viewBox='0 0 48 102'
      {...props}
    >
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#0827C7'
          d='M4 0h40c2.21 0 4 1.79 4 4v96.001c0 1.105-.895 2-2 2-.433 0-.853-.14-1.2-.4L23.987 86 3.2 101.598c-.883.663-2.137.485-2.8-.399-.26-.346-.4-.767-.4-1.2V4c0-2.21 1.79-4 4-4z'
        />
        <g>
          <path d='M0 0H24V24H0z' transform='translate(12 40)' />
          <path
            fill='#FFF'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M20 0c.513 0 .936.386.993.883L21 1v15c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L19 16V2H4v18.5c0 .78.595 1.42 1.355 1.493l.094.005.042-.005c.159-.027.38-.088.607-.19l.17-.085C6.75 21.452 7 21.09 7 20.5V19c0-.552.448-1 1-1h15c.552 0 1 .448 1 1v1.5c0 1.933-1.567 3.5-3.5 3.5h-15c-1.869 0-3.395-1.464-3.495-3.308L2 20.5V1c0-.513.386-.936.883-.993L3 0h17zm2 20H9v.5c0 .536-.104 1.015-.295 1.434L8.672 22H20.5c.78 0 1.42-.595 1.493-1.355L22 20.5V20zm-7-7c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 15H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 13h7zm0-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 11H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 9h7zm0-4c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L15 7H8c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L8 5h7z'
            transform='translate(12 40)'
          />
        </g>
      </g>
    </svg>
  );
}
export function VideoIcon({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      viewBox='0 0 36 29'
      {...props}
    >
      <path
        fill='none'
        fillRule='evenodd'
        stroke='#FFF'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.392'
        d='M23.174 13l-8.87-6v13.5l8.87-7.5zM33.48 28H2.521C1.681 28 1 27.309 1 26.457V2.543C1 1.69 1.681 1 2.521 1H33.48C34.319 1 35 1.691 35 2.543v23.914C35 27.31 34.319 28 33.479 28zM8.392 28H2.479C1.662 28 1 27.329 1 26.5v-24C1 1.67 1.662 1 2.479 1h5.913v27zm25.13 0h-5.913V1h5.913C34.339 1 35 1.671 35 2.5v24c0 .829-.661 1.5-1.478 1.5zM1 10h7.392H1zm0 9h7.392H1zm26.609-9H35h-7.391zm0 9H35h-7.391z'
      />
    </svg>
  );
}
export function GreenPlus2({ fill = 'currentColor', ...props }) {
  return (
    <svg
      xmlns='https://www.w3.org/2000/svg'
      width='60'
      height='104'
      viewBox='0 0 60 104'
      {...props}
    >
      <g fill='none' fillRule='evenodd'>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(15 60)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(15 60)'
          />
        </g>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(45 60)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(45 60)'
          />
        </g>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(0 29)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(0 29)'
          />
        </g>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(30 29)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(30 29)'
          />
        </g>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(45)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(45)'
          />
        </g>
        <g>
          <path d='M0 0H29V29H0z' transform='translate(-7 -7) translate(30 89)' />
          <path
            fill='#55DCAC'
            strokeLinecap='round'
            strokeLinejoin='round'
            d='M14.5 7.25c.637 0 1.159.493 1.205 1.118l.003.09v4.833h4.834c.667 0 1.208.542 1.208 1.209 0 .637-.493 1.159-1.118 1.205l-.09.003h-4.834v4.834c0 .667-.54 1.208-1.208 1.208-.637 0-1.159-.493-1.205-1.118l-.003-.09-.001-4.834H8.458c-.667 0-1.208-.54-1.208-1.208 0-.637.493-1.159 1.118-1.205l.09-.003 4.833-.001V8.458c0-.667.542-1.208 1.209-1.208z'
            transform='translate(-7 -7) translate(30 89)'
          />
        </g>
      </g>
    </svg>
  );
}

export function FaqImage({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='144' height='287' viewBox='0 0 144 287'>
      <defs>
        <linearGradient id='njlk71mr8a' x1='0%' x2='100%' y1='50.003%' y2='50.003%'>
          <stop offset='0%' stopColor='#FFF' />
          <stop offset='100%' stopColor='#DDE5FC' />
        </linearGradient>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g transform='translate(-205 -164) translate(205 164)'>
            <ellipse
              cx='100.311'
              cy='261.669'
              fill='#E6E8F3'
              fillRule='nonzero'
              rx='43.22'
              ry='24.779'
            />
            <path
              fill='#55DCAC'
              fillRule='nonzero'
              d='M120.773 118.2l-9.099-9.334-16.28-2.234c-1.158.466-2.205 1.171-3.073 2.069 0 0-4.782 0-5.969 5.438-1.187 5.439-7.668 20.671-7.668 20.671l-14.537-1.304-1.304 7.964 13.41 4.717c2.812.986 5.911.724 8.517-.722.082 10.103.939 18.18.939 18.18 14.402 17.236 30.573 3.069 30.573 3.069 1.335-9.483 4.291-18.666 8.738-27.148 7.32-13.811-4.247-21.366-4.247-21.366z'
            />
            <path
              fill='#75EABD'
              fillRule='nonzero'
              d='M127.45 129.298c-.704-7.243-6.599-11.098-6.599-11.098l-9.098-9.334-20.367-.217c-3.043 1.178-3.438 1.456-5.025 5.486 7.894 5.938 38.868 27.23 41.09 15.163z'
            />
            <path
              fill='#281DE2'
              fillRule='nonzero'
              d='M98.355 97.124s-10.933 1.957-10.738-3.912c.196-5.869 9.76-11.59 19.393-7.225 9.633 4.365 5.147 17.91 3.552 19.215-1.596 1.304-12.207-8.078-12.207-8.078z'
            />
            <path
              fill='#3A52D2'
              fillRule='nonzero'
              d='M100.928 94.677s6.521-2.787 7.651-7.703c-.496-.336-1.021-.626-1.57-.87-9.632-4.377-19.196 1.348-19.387 7.221-.192 5.873 10.733 3.912 10.733 3.912s1.739 1.544 3.912 3.291l-1.339-5.851z'
            />
            <path
              fill='#F2CAE7'
              fillRule='nonzero'
              d='M90.173 96.407s1.365 18.293 6.556 18.158l2.434-.434 1.74 6.325s8.654-4.065 10.763-11.594l-1.248-4.208s1.578-6.777.226-7.677c-1.352-.9-2.634 1.204-2.634 3.477l-1.13.679-5.934-6.547s-6.382 3.356-10.773 1.821z'
            />
            <path
              fill='#F2F2F2'
              fillRule='nonzero'
              d='M99.163 114.135s-4.547 4.443-4.699 9.325l6.447-3.004-1.748-6.321z'
            />
            <path
              fill='#48CC9A'
              fillRule='nonzero'
              d='M127.16 133.55c-.271-1.369-.615-2.721-1.031-4.052l-21.362 19.966-9.725.17-10.272-2.482s15.789 25.04 33.173 11.059l1.239-4.417c1.148-5.182 1.574-6.22 5.817-14.228 1.027-1.882 1.756-3.911 2.16-6.017z'
            />
            <path
              fill='#F2F2F2'
              fillRule='nonzero'
              d='M113.026 110.231s-.639 11.446-9.859 16.641l-2.234-6.412c5.029-2.22 8.922-6.414 10.763-11.594l1.33 1.365z'
            />
            <path
              fill='#3A52D2'
              fillRule='nonzero'
              d='M119.178 259.487s-.161 19.306-11.099 19.467c-10.433.152.944-17.963.944-17.963l10.155-1.504z'
            />
            <path
              fill='#0827C7'
              fillRule='nonzero'
              d='M100.911 120.46L97.177 122.199 98.155 124.307 91.378 160.219 92.96 166.505 96.142 163.649 100.733 125.633 102.667 125.503zM103.897 247.989l1.335 6.999s-4.117 4.347-10.229 3.134l-.604-1.409s-15.137 8.973-19.276 2.774c-4.138-6.2 14.78-12.863 14.78-12.863s5.44 1.93 13.994 1.365z'
            />
            <path
              fill='#55DCAC'
              fillRule='nonzero'
              d='M118.726 126.285l-17.246 19.397-20.188-14.676s-.826 6.286-6.52 6.169c0 0 12.28 14.78 27.06 21.036 0 0 17.324-8.195 23.688-22.927 1.102-2.47 1.102-5.293 0-7.764-.77-1.67-2.047-3.043-4.156-2.734-1.026.181-1.958.71-2.638 1.5z'
            />
            <path
              fill='#0827C7'
              fillRule='nonzero'
              d='M58.252 124.012l5.217 2.13c1.13.46 1.995 1.403 2.356 2.569l4.082 13.172c.157.473.042.994-.299 1.357-.341.363-.854.51-1.336.382l-5.486-1.413c-1.454-.374-2.586-1.513-2.952-2.97l-3.395-13.623c-.13-.495.03-1.02.414-1.36.383-.338.924-.433 1.4-.244z'
            />
            <path
              fill='#F2CAE7'
              fillRule='nonzero'
              d='M56.144 130.033c.08-.48.411-.88.867-1.048.455-.17.966-.084 1.341.226 2.091 1.739 5.604 4.6 7.955 6.086 3.53 2.27-2.608 9.246-6.433 6.52-3.439-2.43-4.878-5.125-3.73-11.784zM66.125 130.241s9.224-3.738 11.45-2.504c1.434.838 2.689 1.949 3.695 3.27 0 0-.843 6.216-6.52 6.168 0 0-3.209-1.939-3.843-4.843h-4.078l-.704-2.09z'
            />
            <path
              fill='#0827C7'
              fillRule='nonzero'
              d='M89.9 246.624s8.49 6.281 14.002 1.365l-1.583-64.186-15.784-14.92s-1.765 32.652 3.364 77.74z'
            />
            <path
              fill='#3A52D2'
              fillRule='nonzero'
              d='M116.287 166.714s-.291 55.522 4.347 87.47c.301 2.064-.25 4.162-1.53 5.81-1.278 1.649-3.173 2.706-5.247 2.927-3.974.431-7.613-2.26-8.364-6.186-2.674-14.01-8.43-45.897-8.934-64.59-.148-4.056-1.682-7.938-4.347-10.998-2.634-3.087-5.616-8.477-6.52-17.49.021-.012 12.784 16.72 30.595 3.057z'
            />
            <path
              fill='#75EABD'
              fillRule='nonzero'
              d='M81.27 131.006L101.48 145.682 101.48 148.825z'
            />
            <path
              fill='#D3ABCA'
              fillRule='nonzero'
              d='M99.163 114.135L103.224 113.135 100.05 117.343zM70.928 132.332L74.28 132.332 71.572 133.954z'
            />
            <path
              fill='#0827C7'
              fillRule='nonzero'
              d='M108.61 261.67s6.086 3.342 10.568-2.174c0 0-5.195 7.907-11.92 4.616l1.352-2.443z'
            />
            <path stroke='#0827C7' strokeWidth='.5' d='M101.25 176.06s2.643 2.643 11.303 3.083' />
            <path stroke='#F2F2F2' strokeWidth='.5' d='M98.098 136.736L100.924 138.201' />
            <path
              fill='#D3ABCA'
              fillRule='nonzero'
              d='M66.125 140.127c-10.077-1.304-10.286-7.751-10.29-7.795-.435 5.026 1.026 7.36 4.039 9.507 2.021 1.444 4.703.153 6.25-1.712zM90.352 98.246s6.264.765 10.576-3.569c0 0-5.977 2.726-10.755 1.739l.179 1.83z'
            />
            <path
              fill='url(#njlk71mr8a)'
              fillRule='nonzero'
              d='M80.27 64.29c.061-21.8-15.267-48.353-34.242-59.308-18.976-10.955-34.4-2.174-34.46 19.645-.061 21.818 15.267 48.349 34.238 59.3 3.43 2.055 7.184 3.51 11.103 4.303l10.394 14.176-2.035-14.158c9.025-1.935 14.963-10.434 15.003-23.958z'
            />
            <path
              fill='#55DCAC'
              fillRule='nonzero'
              d='M58.113 104.332c.035-11.916-8.347-26.43-18.715-32.417-10.368-5.986-18.805-1.182-18.84 10.738-.035 11.92 8.346 26.426 18.719 32.412 1.88 1.125 3.938 1.92 6.086 2.352l5.664 7.781-1.113-7.75c4.934-1.07 8.177-5.726 8.2-13.116z'
            />
            <path
              fill='#FFF'
              fillRule='nonzero'
              d='M40.463 97.155L37.955 95.703 37.394 84.405 41.063 86.522zM40.742 99.807c.378.628.585 1.344.6 2.078 0 .7-.205 1.165-.609 1.395-.404.23-.904.174-1.495-.17-.646-.381-1.178-.93-1.54-1.586-.382-.63-.589-1.35-.6-2.087 0-.682.205-1.143.61-1.382.404-.24.921-.178 1.543.182.628.38 1.143.922 1.49 1.57z'
            />
            <path
              fill='#F74720'
              fillRule='nonzero'
              d='M98.494 58.417c.035-11.915-8.347-26.43-18.715-32.417-10.368-5.986-18.806-1.182-18.84 10.738-.035 11.92 8.346 26.426 18.719 32.417 1.88 1.121 3.939 1.915 6.086 2.347l5.681 7.751-1.113-7.75c4.917-1.048 8.16-5.7 8.182-13.086z'
            />
            <path
              fill='#FFF'
              fillRule='nonzero'
              d='M84.418 45.028c.23.673.347 1.38.347 2.091 0 .87-.178 1.47-.53 1.834-.393.392-.862.698-1.378.9-.456.192-.835.37-1.139.535-.31.164-.492.498-.46.848v.295c0 .092 0 .187.034.283l-2.608-1.5c-.077-.227-.137-.46-.178-.695-.046-.234-.07-.471-.07-.709-.008-.27.047-.538.16-.782.107-.207.255-.39.436-.535.176-.142.372-.258.582-.344l.64-.26c.364-.123.71-.294 1.03-.51.243-.218.364-.543.321-.868-.004-.516-.155-1.02-.435-1.452-.244-.424-.593-.779-1.013-1.03-.839-.483-1.46-.179-1.878.908l-2.525-2.717c.335-1.152.904-1.83 1.695-2.026.791-.196 1.739 0 2.808.635.633.373 1.217.822 1.74 1.339.539.523 1.016 1.106 1.42 1.739.415.63.75 1.31 1 2.021zM80.088 52.9c.636.378 1.156.922 1.504 1.574.371.63.573 1.344.587 2.074 0 .7-.204 1.165-.6 1.4-.396.235-.9.174-1.508-.174-.644-.382-1.174-.928-1.535-1.582-.386-.632-.593-1.356-.6-2.096 0-.682.204-1.139.609-1.378.404-.239.917-.178 1.543.183z'
            />
            <path
              stroke='#A9B3CE'
              strokeLinecap='round'
              strokeWidth='1.304'
              d='M35.512 43.685L56.326 56.022M35.512 34.243L56.326 46.584M35.512 53.192L45.919 59.361'
            />
            <path
              stroke='#281DE2'
              strokeWidth='.5'
              d='M34.534 134.01c1.386.907 2.26 2.42 2.352 4.074 0 1.5-1.065 2.1-2.37 1.347-1.39-.903-2.265-2.417-2.351-4.073.004-1.496 1.065-2.1 2.369-1.348z'
            />
            <path
              stroke='#F74720'
              strokeWidth='.5'
              d='M113.226 65.068c1.388.906 2.26 2.42 2.348 4.074 0 1.5-1.06 2.1-2.365 1.347-1.391-.902-2.265-2.417-2.352-4.073-.004-1.495 1.065-2.078 2.37-1.348z'
            />
            <path
              stroke='#55DCAC'
              strokeWidth='.5'
              d='M2.652 60.147c1.39.904 2.265 2.418 2.352 4.074 0 1.5-1.065 2.1-2.365 1.347C1.249 64.667.374 63.154.287 61.5c.004-1.508 1.06-2.104 2.365-1.352z'
            />
            <path
              fill='#FFF'
              fillRule='nonzero'
              d='M39.398 71.924c-10.372-5.986-18.805-1.183-18.84 10.737 0 4.313 1.087 8.969 2.973 13.438 8.673.825 21.758-.092 28.479-11.273-3.322-5.412-7.751-10.094-12.612-12.902zM79.78 26c-10.373-5.986-18.807-1.182-18.841 10.738 0 6.23 2.269 13.172 5.938 19.232 8.455-1.044 17.45-5.117 21.214-16.772.61-1.862.726-3.852.335-5.773-2.44-2.947-5.364-5.458-8.647-7.425z'
              opacity='.2'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function SearchIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <path d='M0 0H16V16H0z' transform='translate(-32 -499) translate(0 483) translate(32 16)' />
        <g fill='#B5B5B5' fillRule='nonzero'>
          <path
            d='M13.314 11.9l2.393 2.393c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293-.256 0-.512-.098-.707-.293L11.9 13.314c.529-.411 1.003-.885 1.414-1.414zM7 0c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z'
            transform='translate(-32 -499) translate(0 483) translate(32 16)'
          />
        </g>
      </g>
    </svg>
  );
}

export function StarIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <path
                d='M0 0H16V16H0z'
                transform='translate(-48 -928) translate(24 912) translate(24 16)'
              />
              <g fill='#55DCAC'>
                <path
                  d='M15.144 5.438l-4.316-.627L8.897.9C8.559.217 7.441.217 7.103.9l-1.93 3.911-4.317.627C.039 5.557-.292 6.565.302 7.145l3.124 3.044-.737 4.299c-.139.814.717 1.439 1.451 1.054L8 13.513l3.861 2.03c.728.381 1.591-.234 1.451-1.054l-.737-4.299 3.124-3.044c.593-.581.262-1.589-.555-1.708z'
                  transform='translate(-48 -928) translate(24 912) translate(24 16)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function SearchPaperIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M0 0H24V24H0z'
                  transform='translate(-176 -1932) translate(79 1900) translate(81 16) translate(16 16)'
                />
                <g fill='#0827C7' strokeLinecap='round' strokeLinejoin='round'>
                  <path
                    d='M15 18c.414 0 .75.336.75.75 0 .385-.29.702-.663.745L15 19.5H.75c-.414 0-.75-.336-.75-.75 0-.385.29-.702.663-.745L.75 18H15zm0-13.5c2.9 0 5.25 2.35 5.25 5.25 0 1.18-.389 2.268-1.045 3.144l3.075 3.076c.293.293.293.767 0 1.06-.27.27-.695.291-.99.063l-.07-.063-3.076-3.075C17.268 14.61 16.179 15 15 15c-2.9 0-5.25-2.35-5.25-5.25S12.1 4.5 15 4.5zM7.5 12c.414 0 .75.336.75.75 0 .385-.29.702-.663.745L7.5 13.5H.75c-.414 0-.75-.336-.75-.75 0-.385.29-.702.663-.745L.75 12H7.5zM15 6c-2.071 0-3.75 1.679-3.75 3.75 0 2.071 1.679 3.75 3.75 3.75 2.071 0 3.75-1.679 3.75-3.75C18.75 7.679 17.071 6 15 6zM7.5 6c.414 0 .75.336.75.75 0 .385-.29.702-.663.745L7.5 7.5H.75C.336 7.5 0 7.164 0 6.75c0-.385.29-.702.663-.745L.75 6H7.5zM15 0c.414 0 .75.336.75.75 0 .385-.29.702-.663.745L15 1.5H.75C.336 1.5 0 1.164 0 .75 0 .365.29.048.663.005L.75 0H15z'
                    transform='translate(-176 -1932) translate(79 1900) translate(81 16) translate(16 16) translate(.75 2.25)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PlusIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g fill='#0727C7' fillRule='nonzero'>
          <g>
            <g>
              <path
                d='M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z'
                transform='translate(-48 -790) translate(32 764) translate(16 26)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function MinusIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='2' viewBox='0 0 16 2' {...props}>
      <g fill='none' fillRule='evenodd'>
        <g fill='#0727C7' fillRule='nonzero'>
          <g>
            <g>
              <path
                d='M15 0H1C.4 0 0 .4 0 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z'
                transform='translate(-48 -670) translate(32 635) translate(16 35)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function CoinsIconFaq({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF' fillRule='nonzero'>
          <g>
            <g>
              <g transform='translate(-44 -559) translate(0 531) translate(32 16) translate(12.5 12.5)'>
                <path d='M10.625 9.885c-1.844 0-3.377-.423-4.375-1.135v1.135c0 1.1 1.959 1.99 4.375 1.99S15 10.985 15 9.885V8.75c-.998.712-2.53 1.135-4.375 1.135zM10.625 13.01c-1.844 0-3.377-.423-4.375-1.135v1.135c0 1.1 1.959 1.99 4.375 1.99S15 14.11 15 13.01v-1.135c-.998.712-2.53 1.135-4.375 1.135z' />
                <ellipse cx='10.625' cy='6.875' rx='4.375' ry='1.875' />
                <ellipse cx='4.375' cy='1.875' rx='4.375' ry='1.875' />
                <path d='M5 11.117c-.204.011-.412.018-.625.018C2.531 11.135.998 10.712 0 10v1.135c0 1.1 1.959 1.99 4.375 1.99.213 0 .42-.01.625-.023v-1.985zM5 7.992c-.204.011-.412.018-.625.018C2.531 8.01.998 7.587 0 6.875V8.01C0 9.11 1.959 10 4.375 10c.213 0 .42-.01.625-.023V7.992zM6.25 4.73c-.568.1-1.183.155-1.84.155-1.859 0-3.404-.423-4.41-1.135v1.135c0 1.1 1.975 1.99 4.41 1.99.215 0 .425-.01.632-.023.008-.837.446-1.565 1.208-2.122z' />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function RefundIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <path
                  d='M11.999 10.143c.02.573-.234 1.124-.687 1.49-.556.41-1.228.644-1.925.672V13.5H8.57v-1.172c-.878 0-1.747-.17-2.557-.5v-1.54c.4.187.82.336 1.25.444.426.117.864.193 1.306.227V9.152L8.167 9c-.627-.204-1.2-.541-1.676-.988-.33-.362-.506-.834-.49-1.32-.01-.54.24-1.055.678-1.389.55-.398 1.208-.627 1.891-.66V3.75h.818v.868c.852.026 1.691.207 2.474.536l-.561 1.364c-.611-.246-1.257-.4-1.916-.455v1.72c.577.198 1.133.452 1.658.757.293.179.54.42.723.706.159.273.24.583.233.897zm-4.2-3.45c-.005.16.061.314.182.422.177.144.375.26.59.342v-1.37c-.515.074-.772.276-.772.606zM10.2 10.23c.001-.16-.074-.313-.203-.414-.187-.142-.392-.26-.61-.35v1.452c.542-.09.813-.319.813-.688z'
                  transform='translate(-43 -631) translate(0 604) translate(32 16) translate(11 11)'
                />
                <path
                  d='M8.625.119C6.653.114 4.74.815 3.209 2.103L1.045 0 .54 6.164l5.959-.863-2.13-2.067c2.133-1.68 5-1.962 7.4-.727 2.4 1.236 3.917 3.775 3.914 6.552v.016c-.004 4.04-3.167 7.311-7.064 7.307-3.898-.004-7.054-3.283-7.05-7.323 0-.449-.35-.812-.784-.812-.433 0-.784.363-.784.812C0 13.997 3.862 18 8.625 18s8.625-4.003 8.625-8.94c0-4.938-3.862-8.941-8.625-8.941z'
                  transform='translate(-43 -631) translate(0 604) translate(32 16) translate(11 11)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PeopleIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='18' viewBox='0 0 22 18'>
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <path
                  d='M15.111 0c-.804 0-1.538.277-2.133.727.778 1.038 1.244 2.323 1.244 3.717v.89c0 .846-.171 1.654-.48 2.391.422.176.884.275 1.37.275 1.963 0 3.555-1.592 3.555-3.556v-.888C18.667 1.592 17.075 0 15.11 0zM8 9.778c-2.454 0-4.444-1.99-4.444-4.445v-.889C3.556 1.99 5.546 0 8 0c2.454 0 4.444 1.99 4.444 4.444v.89c0 2.454-1.99 4.444-4.444 4.444zM20.301 11.027c-1.141-.525-3.097-1.25-5.19-1.25-1.062 0-2.089.188-2.993.44.334.07.67.14 1.005.226 2.587.66 4.417 2.91 4.615 5.557h2.706c.491 0 .89-.398.89-.889v-2.47c0-.695-.4-1.325-1.033-1.614zM15.111 17.778H.89c-.49 0-.889-.398-.889-.89v-.421c0-2.023 1.357-3.802 3.316-4.302 1.31-.334 2.925-.61 4.684-.61 1.76 0 3.373.276 4.684.61 1.959.5 3.316 2.28 3.316 4.302v.422c0 .49-.398.889-.889.889z'
                  transform='translate(-41 -704) translate(0 677) translate(32 16) translate(9 11)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function PaperIcon({ ...props }) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <path
                  d='M17.25 0h-12c-.415 0-.75.335-.75.75v12H2.25C1.01 12.75 0 13.76 0 15v3h10.5v-2.687c0-.606.484-1.063 1.125-1.063.542 0 1.125.352 1.125 1.125 0 1.448 1.178 2.625 2.625 2.625C16.823 18 18 16.823 18 15.375V.75c0-.415-.335-.75-.75-.75zM9 15.313V16.5H1.5V15c0-.414.336-.75.75-.75h6.978c-.147.322-.228.682-.228 1.063zm6-5.563H7.5v-1.5H15v1.5zm0-4.5H7.5v-1.5H15v1.5z'
                  transform='translate(-43 -777) translate(0 750) translate(32 16) translate(11 11)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
export function BlueMotif({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='175'
      height='170'
      viewBox='0 0 175 170'
      {...props}
    >
      <g fill='none' fillOpacity='.03' fillRule='evenodd'>
        <g fill='#0727C7'>
          <g>
            <path
              d='M428.036 99.793h165.01L578.15 119.26l-.084.112v33.706H452.97v-33.58h-16.166v50.49l157.428.012V82.871H437.978l14.908-19.717.084-.113 8.768-33.392 89.748 5.266 26.58 28.991h16.166V12.727H603v-100.7l-141.31-75.175V-182H428l.036 281.793zm93.71-104.365l8.864-.112V-82L567-63.482V15h-60l14.746-19.572zM462.56-4.76l.083-.113v-110.012l-.012-3.115L499-98.505v111.26L439 15l23.56-19.76z'
              transform='translate(-491 -636) translate(63 636) rotate(-180 515.5 -6)'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export function SmartTourIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_475)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M15.7486 17.5686H7.34315C6.51858 17.5686 5.80544 16.9111 5.80544 16.0309V9.932C5.80544 9.10743 6.46286 8.39429 7.34315 8.39429H15.7486C16.5731 8.39429 17.2863 9.05172 17.2863 9.932V16.0829C17.2863 16.9074 16.6289 17.5649 15.7486 17.5649V17.5686Z'
          fill='white'
        />
        <path
          d='M20.8 16.8554C20.6886 16.8554 20.5809 16.8554 20.5251 16.7997L16.6809 15.262C16.406 15.1506 16.1869 14.8757 16.1869 14.5489V11.4734C16.1869 11.1429 16.3503 10.868 16.6809 10.7603L20.5251 9.22257C20.7443 9.11114 21.0191 9.16686 21.2383 9.27829C21.4574 9.44172 21.5689 9.66457 21.5689 9.93572V16.0866C21.5689 16.3614 21.4574 16.5806 21.2383 16.744C21.0749 16.7997 20.9634 16.8554 20.8 16.8554ZM17.3383 14.3297L20.4137 15.5369V10.374L17.3383 11.5811V14.326V14.3297Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_475'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function CostSegIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_467)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M11.7483 11.7557C11.7483 12.1309 12.2311 12.3426 12.7103 12.506V10.9534C12.1234 11.0611 11.7483 11.3806 11.7483 11.7557Z'
          fill='white'
        />
        <path
          d='M13.0334 7.8483C10.1957 7.8483 7.89658 10.1474 7.89658 12.9852C7.89658 15.8229 10.1957 18.122 13.0334 18.122C15.8711 18.122 18.1703 15.8229 18.1703 12.9852C18.1703 10.1474 15.8711 7.8483 13.0334 7.8483ZM15.1209 11.7557C15.1209 11.9712 14.9611 12.1309 14.7457 12.1309C14.5303 12.1309 14.3706 11.9712 14.3706 11.7557C14.3706 11.3806 13.9434 11.0612 13.4086 10.9534V12.6657C14.534 12.9332 15.1209 13.416 15.1209 14.1626C15.1209 14.9649 14.4263 15.5554 13.4086 15.7152V16.302C13.4086 16.5174 13.2489 16.6772 13.0334 16.6772C12.818 16.6772 12.6583 16.5174 12.6583 16.302V15.7152C11.6963 15.6074 10.946 14.9649 10.946 14.1626C10.946 13.9472 11.1057 13.7874 11.3211 13.7874C11.5366 13.7874 11.6963 13.9472 11.6963 14.1626C11.6963 14.5377 12.1234 14.8572 12.6583 14.9649V13.2526C11.5329 12.9852 10.946 12.4503 10.946 11.7557C10.946 10.9534 11.6406 10.3629 12.6583 10.2032V9.6163C12.6583 9.40087 12.818 9.24115 13.0334 9.24115C13.2489 9.24115 13.4086 9.40087 13.4086 9.6163V10.2032C14.3706 10.3629 15.1209 11.0054 15.1209 11.7557Z'
          fill='white'
        />
        <path
          d='M13.4086 14.9649C13.9434 14.8571 14.3706 14.5377 14.3706 14.1626C14.3706 13.7874 13.9434 13.5757 13.4086 13.4123V14.9649Z'
          fill='white'
        />
        <path
          d='M17.368 19.6226C14.3706 21.6543 10.3591 21.3869 7.62914 18.98C5.80914 17.3754 4.84714 15.0726 4.89914 12.7177L6.344 13.0929L5.32629 9.24115L2.48857 12.0789L3.98543 12.506C3.82571 15.236 4.94743 17.9103 6.98286 19.7303C8.64314 21.2271 10.7826 21.9774 12.87 21.9774C14.5823 21.9774 16.2946 21.4946 17.8471 20.4806C18.0626 20.3209 18.1146 20.0534 17.9549 19.838C17.8471 19.5186 17.5797 19.4629 17.368 19.6226Z'
          fill='white'
        />
        <path
          d='M21.8066 13.52C21.9663 10.79 20.8446 8.1157 18.8091 6.2957C15.7597 3.62142 11.3174 3.35399 7.94486 5.60113C7.72943 5.76085 7.67743 6.02828 7.83714 6.2437C7.99686 6.45913 8.26429 6.51113 8.47971 6.35142C11.4771 4.3197 15.4886 4.58713 18.2186 6.99399C20.0386 8.59856 21.0006 10.9014 20.9486 13.2563L19.5037 12.8811L20.5214 16.7328L23.3591 13.8951L21.8066 13.52Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_467'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SpecsExperienceIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_8_180)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M13 19.6857C16.6924 19.6857 19.6857 16.6924 19.6857 13C19.6857 9.30758 16.6924 6.31429 13 6.31429C9.30758 6.31429 6.31429 9.30758 6.31429 13C6.31429 16.6924 9.30758 19.6857 13 19.6857Z'
          fill='white'
        />
        <path
          d='M13.0891 13.9546C13.6594 13.9546 14.1217 13.4923 14.1217 12.922C14.1217 12.3517 13.6594 11.8894 13.0891 11.8894C12.5189 11.8894 12.0566 12.3517 12.0566 12.922C12.0566 13.4923 12.5189 13.9546 13.0891 13.9546Z'
          fill='#55DCAC'
        />
        <path
          d='M13.0891 12.922L16.224 9.54942'
          stroke='#55DCAC'
          strokeWidth='0.387'
          strokeMiterlimit='10'
        />
      </g>
      <defs>
        <clipPath id='clip0_8_180'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function AboutMadisonSpecsIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_480)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M9.85033 12.6991V5.82399L12.8998 7.32828V13.7726H9.03318L9.85033 12.6991ZM13.8023 12.6991V7.75913L16.8518 9.26342V13.7726H12.9406L13.7986 12.6991H13.8023ZM8.94775 18.4117H17.7135L16.8555 19.4443V21.2494H9.85033V19.4443H8.94775V22.152H17.7543V17.5128H9.0369L9.85404 16.4394V14.6343H16.8555V16.4803H17.758V13.7317H16.9L17.758 12.6583V8.70628L9.85033 4.83599V3.84799H8.94775V18.4117Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_480'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function MeetYourTeamIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_483)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M10.7715 11.596C11.3101 12.3797 12.1941 12.87 13.223 12.87C14.1552 12.87 14.939 12.428 15.4775 11.7929C15.8712 11.3026 16.1164 10.6674 16.1647 9.9803V9.93201C16.1647 8.3163 14.8424 6.9903 13.223 6.9903C11.6035 6.9903 10.2812 8.31258 10.2812 9.93201V10.1772C10.3295 10.6674 10.4781 11.1577 10.7715 11.5997V11.596Z'
          fill='white'
          stroke='white'
          strokeWidth='0.83'
          strokeMiterlimit='10'
        />
        <path
          d='M17.0931 14.9277L16.6994 14.534C15.7671 13.7503 14.5414 13.26 13.2191 13.26C11.8968 13.26 10.6711 13.7503 9.73884 14.5823C9.59027 14.6789 9.44541 14.8274 9.34512 14.976C8.51312 15.8563 7.97455 17.082 7.87427 18.408V18.8983H18.5566V18.408C18.5083 17.0374 17.9177 15.86 17.0857 14.9277H17.0931Z'
          fill='white'
          stroke='white'
          strokeWidth='0.83'
          strokeMiterlimit='10'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_483'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function CaseStudiesIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_487)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M14.3966 6.76H8.29034C7.59577 6.76 7.08691 7.31343 7.08691 7.96343V16.5211C7.08691 17.2157 7.64034 17.7246 8.29034 17.7246H14.3966C15.0912 17.7246 15.6001 17.1711 15.6001 16.5211V7.95972C15.6001 7.31343 15.0466 6.75629 14.3966 6.75629V6.76Z'
          fill='white'
        />
        <path
          d='M9.21533 9.90228H13.4273'
          stroke='#55DCAC'
          strokeWidth='0.449429'
          strokeMiterlimit='10'
        />
        <path
          d='M9.21533 11.8931H11.3436'
          stroke='#55DCAC'
          strokeWidth='0.449429'
          strokeMiterlimit='10'
        />
        <path
          d='M12.2238 11.4289C13.8432 9.80944 16.432 9.80944 18.0515 11.4289C19.5335 12.9109 19.6709 15.2212 18.4229 16.8406L20.9226 19.3403C21.1529 19.5706 21.1529 19.942 20.9226 20.1723C20.6923 20.4026 20.3209 20.4026 20.0906 20.1723L17.5909 17.6726C15.9715 18.876 13.6575 18.7349 12.1792 17.3012C10.608 15.6817 10.608 13.0446 12.2238 11.4252V11.4289Z'
          fill='white'
        />
        <path
          d='M12.8701 12.1234C14.1181 10.8754 16.1535 10.8754 17.4015 12.1234C18.6495 13.3714 18.6495 15.4069 17.4015 16.6549C16.1535 17.9029 14.1181 17.9029 12.8701 16.6549C11.6221 15.3586 11.6221 13.3714 12.8701 12.1234Z'
          fill='#55DCAC'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_487'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function OurFootprintIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_13_494)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M13.2598 5.95029C10.3032 5.95029 7.92236 8.33114 7.92236 11.2877C7.92236 15.08 13.2598 20.904 13.2598 20.904C13.2598 20.904 18.5972 15.08 18.5972 11.2877C18.6418 8.37572 16.2164 5.95029 13.2598 5.95029ZM13.2598 13.9806C11.8038 13.9806 10.5669 12.7883 10.5669 11.2877C10.5669 9.78714 11.7592 8.59486 13.2598 8.59486C14.7604 8.59486 15.9526 9.78714 15.9526 11.2877C15.9526 12.7883 14.7604 13.9806 13.2598 13.9806Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_13_494'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function FAQsIcon({ ...props }) {
  return (
    <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1_2)'>
        <path
          d='M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z'
          fill='#55DCAC'
        />
        <path
          d='M9.21516 9.90229H13.4272'
          stroke='#55DCAC'
          strokeWidth='0.449429'
          strokeMiterlimit='10'
        />
        <path
          d='M9.21516 11.8931H11.3435'
          stroke='#55DCAC'
          strokeWidth='0.449429'
          strokeMiterlimit='10'
        />
        <path
          d='M12.87 12.1234C14.118 10.8754 16.1534 10.8754 17.4014 12.1234C18.6494 13.3714 18.6494 15.4069 17.4014 16.6549C16.1534 17.9029 14.118 17.9029 12.87 16.6549C11.622 15.3586 11.622 13.3714 12.87 12.1234V12.1234Z'
          fill='#55DCAC'
        />
        <path
          d='M11 22V18.2388C11 18.2388 16.29 17.7015 14.703 18.2388C13.116 18.7761 11 22 11 22Z'
          fill='white'
        />
        <rect x='8' y='7' width='10' height='12' rx='2' fill='white' />
      </g>
      <defs>
        <clipPath id='clip0_1_2'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GlossaryIcon({ ...props }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_2_22)'>
        <path
          d='M15.9946 2.12026C15.9946 1.89016 15.8768 1.67555 15.6821 1.54934C15.5674 1.47492 15.4349 1.43712 15.3014 1.43712C15.2082 1.43712 15.1146 1.45557 15.0267 1.49308L8.08121 4.45156C8.05283 4.46346 8.02626 4.47805 8.0003 4.49323C7.97434 4.47805 7.94777 4.46346 7.9194 4.45156L0.973585 1.49308C0.885434 1.45557 0.791849 1.43712 0.698868 1.43712C0.565434 1.43712 0.432906 1.47492 0.318189 1.54934C0.12317 1.67555 0.00573585 1.89016 0.00543396 2.12026L0 12.2864C0 12.5593 0.164226 12.8061 0.418415 12.9141L7.40558 15.8806C7.77992 16.0396 8.20408 16.0399 8.57872 15.8809L15.5816 12.9141C15.8355 12.8058 16 12.559 16 12.2864L15.9946 2.12026Z'
          fill='white'
        />
        <path
          d='M7.0068 2.01548L7.99216 2.43013L12.0465 0.655159C12.1676 0.602175 12.2473 0.486086 12.2524 0.355412C12.262 0.102398 11.9991 -0.0729258 11.7645 0.0303635L7.99819 1.68984L4.21766 0.0300658C3.9831 -0.0729258 3.72046 0.102398 3.73012 0.355114V0.3569C3.73525 0.486682 3.81434 0.602771 3.9348 0.656052L7.0068 2.01578V2.01548Z'
          fill='white'
        />
        <path
          d='M7.9979 3.05134L2.54643 0.658133C2.31397 0.556035 2.05284 0.727489 2.05888 0.978419V0.979014C2.0619 1.11118 2.1422 1.22965 2.26477 1.28352L7.99216 3.79163L13.7165 1.30615C13.8397 1.25257 13.9203 1.1338 13.9233 1.00134V1.00015C13.9294 0.749516 13.6688 0.578062 13.4364 0.679565L7.9979 3.05194V3.05134Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_2_22'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
